import moment from 'moment';
import { fetchCurrentUser } from '../../ducks/user.duck';
import {
  addMemberToSpaceApi,
  advancedSearchApi,
  createBookMarkApi,
  createCommentForPostApi,
  createDislikeForPostApi,
  createLikeDislikeCommentApi,
  createLikeForPostApi,
  createNewCircleUserApi,
  createNewSpaceApi,
  createReplyForACommentApi,
  createSpacePostApi,
  deleteBookMarkApi,
  deleteCirclePostApi,
  deleteCommentFromPostApi,
  deleteSpaceApi,
  directUploadApi,
  editCirclePostApi,
  editCommentApi,
  fetchBookMarkApi,
  fetchCurrentCommunityMember,
  fetchSpaceListApi,
  fetchSpaceListApiV2,
  fetchUserActivityApi,
  flaggedContentApi,
  followCirclePostApi,
  getBookMarksApi,
  getCircleAuthToken,
  getCircleHomePageApi,
  getCommentListForPostApi,
  getListOfReplyForCommentApi,
  getMediaTranscodingStatusApi,
  getMemberDetailApi,
  getNotificationPrefernceApi,
  getNotificationsCountApi,
  getNotificationsListApi,
  getSinglePostApi,
  getSpaceDetailsApi,
  getSpaceMembersApi,
  getSpaceTopicDetailApi,
  getSpaceTopicsApi,
  groupPostSearchApi,
  joinSpaceByIdApi,
  leaveSpaceByIdApi,
  markAllNotificationsAsReadApi,
  markNotificationAsReadApi,
  notificationPreferencesApi,
  onMultiMailApiCollection,
  removeSpaceMemberApi,
  resetNotificationCountApi,
  checkCircleMemberExists,
  trendingTopicsApi,
} from '../../util/api';
import { types as sdkTypes } from '../../util/sdkLoader';
import { parse } from '../../util/urlHelpers';
import { FEED_TAB, LOCAL_STORAGE_CIRCLE_AUTH_TOKEN } from '../../util/types';
import { recordLimit } from '../../util/circleHelper';
import { UploadImage } from '../../util/cloudinary';
import { storableError } from '../../util/errors';


const { UUID } = sdkTypes;
const resultIds = data => data?.data?.map?.(l => l.id);

const groupBySpaceGroupName = data => {
  return data.reduce((acc, item) => {
    const groupName = item.space_group_name;
    if (!acc[groupName]) {
      acc[groupName] = [];
    }
    acc[groupName].push(item);
    return acc;
  }, {});
};

export const SET_INITIAL_STATE = 'app/CirclePage/SET_INITIAL_STATE';
export const REQUEST_ACCESS_TOKEN = 'app/CirclePage/REQUEST_ACCESS_TOKEN';
export const SUCCESS_ACCESS_TOKEN = 'app/CirclePage/SUCCESS_ACCESS_TOKEN';
export const ERROR_ACCESS_TOKEN = 'app/CirclePage/ERROR_ACCESS_TOKEN';
export const REQUEST_HOME_PAGE = 'app/CirclePage/REQUEST_HOME_PAGE';
export const SUCCESS_HOME_PAGE = 'app/CirclePage/SUCCESS_HOME_PAGE';
export const ERROR_HOME_PAGE = 'app/CirclePage/ERROR_HOME_PAGE';
export const REQUEST_CREATE_POST = 'app/CirclePage/REQUEST_CREATE_POST';
export const SUCCESS_CREATE_POST = 'app/CirclePage/SUCCESS_CREATE_POST';
export const ERROR_CREATE_POST = 'app/CirclePage/ERROR_CREATE_POST';
export const REQUEST_LIKE_DISLIKE_POST = 'app/CirclePage/REQUEST_LIKE_DISLIKE_POST';
export const SUCCESS_LIKE_DISLIKE_POST = 'app/CirclePage/SUCCESS_LIKE_DISLIKE_POST';
export const ERROR_LIKE_DISLIKE_POST = 'app/CirclePage/ERROR_LIKE_DISLIKE_POST';
export const REQUEST_CREATE_COMMENT = 'app/CirclePage/REQUEST_CREATE_COMMENT';
export const SUCCESS_CREATE_COMMENT = 'app/CirclePage/SUCCESS_CREATE_COMMENT';
export const ERROR_CREATE_COMMENT = 'app/CirclePage/ERROR_CREATE_COMMENT';
export const REQUEST_DELETE_COMMENT = 'app/CirclePage/REQUEST_DELETE_COMMENT';
export const SUCCESS_DELETE_COMMENT = 'app/CirclePage/SUCCESS_DELETE_COMMENT';
export const ERROR_DELETE_COMMENT = 'app/CirclePage/ERROR_DELETE_COMMENT';
export const REQUEST_COMMUNITY_MEMBER = 'app/CirclePage/REQUEST_COMMUNITY_MEMBER';
export const SUCCESS_COMMUNITY_MEMBER = 'app/CirclePage/SUCCESS_COMMUNITY_MEMBER';
export const ERROR_COMMUNITY_MEMBER = 'app/CirclePage/ERROR_COMMUNITY_MEMBER';
export const REQUEST_SPACE_LIST = 'app/CirclePage/REQUEST_SPACE_LIST';
export const SUCCESS_SPACE_LIST = 'app/CirclePage/SUCCESS_SPACE_LIST';
export const ERROR_SPACE_LIST = 'app/CirclePage/ERROR_SPACE_LIST';
export const REQUEST_SPACE_LISTV2 = 'app/CirclePage/REQUEST_SPACE_LISTV2';
export const SUCCESS_SPACE_LISTV2 = 'app/CirclePage/SUCCESS_SPACE_LISTV2';
export const ERROR_SPACE_LISTV2 = 'app/CirclePage/ERROR_SPACE_LISTV2';
export const REQUEST_CREATE_USER = 'app/CirclePage/REQUEST_CREATE_USER';
export const SUCCESS_CREATE_USER = 'app/CirclePage/SUCCESS_CREATE_USER';
export const ERROR_CREATE_USER = 'app/CirclePage/ERROR_CREATE_USER';
export const REQUEST_DIRECT_UPLOAD = 'app/CirclePage/REQUEST_DIRECT_UPLOAD';
export const SUCCESS_DIRECT_UPLOAD = 'app/CirclePage/SUCCESS_DIRECT_UPLOAD';
export const ERROR_DIRECT_UPLOAD = 'app/CirclePage/ERROR_DIRECT_UPLOAD';
export const REQUEST_NEW_SPACE = 'app/CirclePage/REQUEST_NEW_SPACE';
export const SUCCESS_NEW_SPACE = 'app/CirclePage/SUCCESS_NEW_SPACE';
export const ERROR_NEW_SPACE = 'app/CirclePage/ERROR_NEW_SPACE';
export const REQUEST_JOIN_SPACE = 'app/CirclePage/REQUEST_JOIN_SPACE';
export const SUCCESS_JOIN_SPACE = 'app/CirclePage/SUCCESS_JOIN_SPACE';
export const ERROR_JOIN_SPACE = 'app/CirclePage/ERROR_JOIN_SPACE';
export const REQUEST_COMBINE_SPACE_TOPICS = 'app/CirclePage/REQUEST_COMBINE_SPACE_TOPICS';
export const SUCCESS_COMBINE_SPACE_TOPICS = 'app/CirclePage/SUCCESS_COMBINE_SPACE_TOPICS';
export const ERROR_COMBINE_SPACE_TOPICS = 'app/CirclePage/ERROR_COMBINE_SPACE_TOPICS';
export const REQUEST_LEAVE_SPACE = 'app/CirclePage/REQUEST_LEAVE_SPACE';
export const SUCCESS_LEAVE_SPACE = 'app/CirclePage/SUCCESS_LEAVE_SPACE';
export const ERROR_LEAVE_SPACE = 'app/CirclePage/ERROR_LEAVE_SPACE';
export const REQUEST_CREATE_BOOKMARK = 'app/CirclePage/REQUEST_CREATE_BOOKMARK';
export const SUCCESS_CREATE_BOOKMARK = 'app/CirclePage/SUCCESS_CREATE_BOOKMARK';
export const ERROR_CREATE_BOOKMARK = 'app/CirclePage/ERROR_CREATE_BOOKMARK';
export const REQUEST_DELETE_BOOKMARK = 'app/CirclePage/REQUEST_DELETE_BOOKMARK';
export const SUCCESS_DELETE_BOOKMARK = 'app/CirclePage/SUCCESS_DELETE_BOOKMARK';
export const ERROR_DELETE_BOOKMARK = 'app/CirclePage/ERROR_DELETE_BOOKMARK';
export const REQUEST_BOOKMARKS_LIST = 'app/CirclePage/REQUEST_BOOKMARKS_LIST';
export const SUCCESS_BOOKMARKS_LIST = 'app/CirclePage/SUCCESS_BOOKMARKS_LIST';
export const ERROR_BOOKMARKS_LIST = 'app/CirclePage/ERROR_BOOKMARKS_LIST';
export const REQUEST_SINGLE_POST = 'app/CirclePage/REQUEST_SINGLE_POST';
export const SUCCESS_SINGLE_POST = 'app/CirclePage/SUCCESS_SINGLE_POST';
export const ERROR_SINGLE_POST = 'app/CirclePage/ERROR_SINGLE_POST';
export const REQUEST_POST_COMMENT_LIST = 'app/CirclePage/REQUEST_POST_COMMENT_LIST';
export const SUCCESS_POST_COMMENT_LIST = 'app/CirclePage/SUCCESS_POST_COMMENT_LIST';
export const ERROR_POST_COMMENT_LIST = 'app/CirclePage/ERROR_POST_COMMENT_LIST';
export const REQUEST_LIKE_DISLIKE_COMMENT = 'app/CirclePage/REQUEST_LIKE_DISLIKE_COMMENT';
export const SUCCESS_LIKE_DISLIKE_COMMENT = 'app/CirclePage/SUCCESS_LIKE_DISLIKE_COMMENT';
export const ERROR_LIKE_DISLIKE_COMMENT = 'app/CirclePage/ERROR_LIKE_DISLIKE_COMMENT';
export const REQUEST_CREATE_REPLY_COMMENT = 'app/CirclePage/REQUEST_CREATE_REPLY_COMMENT';
export const SUCCESS_CREATE_REPLY_COMMENT = 'app/CirclePage/SUCCESS_CREATE_REPLY_COMMENT';
export const ERROR_CREATE_REPLY_COMMENT = 'app/CirclePage/ERROR_CREATE_REPLY_COMMENT';
export const REQUEST_SPACE_DETAILS = 'app/CirclePage/REQUEST_SPACE_DETAILS';
export const SUCCESS_SPACE_DETAILS = 'app/CirclePage/SUCCESS_SPACE_DETAILS';
export const ERROR_SPACE_DETAILS = 'app/CirclePage/ERROR_SPACE_DETAILS';
export const REQUEST_TOPIC_DETAILS = 'app/CirclePage/REQUEST_TOPIC_DETAILS';
export const SUCCESS_TOPIC_DETAILS = 'app/CirclePage/SUCCESS_TOPIC_DETAILS';
export const ERROR_TOPIC_DETAILS = 'app/CirclePage/ERROR_TOPIC_DETAILS';
export const REQUEST_SPACE_MEMBERS = 'app/CirclePage/REQUEST_SPACE_MEMBERS';
export const SUCCESS_SPACE_MEMBERS = 'app/CirclePage/SUCCESS_SPACE_MEMBERS';
export const SUCCESS_SPACE_MEMBER_FULL_LIST = 'app/CirclePage/SUCCESS_SPACE_MEMBER_FULL_LIST';
export const ERROR_SPACE_MEMBERS = 'app/CirclePage/ERROR_SPACE_MEMBERS';
export const REQUEST_REMOVE_SPACE_MEMBER = 'app/CirclePage/REQUEST_REMOVE_SPACE_MEMBER';
export const SUCCESS_REMOVE_SPACE_MEMBER = 'app/CirclePage/SUCCESS_REMOVE_SPACE_MEMBER';
export const ERROR_REMOVE_SPACE_MEMBER = 'app/CirclePage/ERROR_REMOVE_SPACE_MEMBER';
export const REQUEST_DELETE_SPACE = 'app/CirclePage/REQUEST_DELETE_SPACE';
export const SUCCESS_DELETE_SPACE = 'app/CirclePage/SUCCESS_DELETE_SPACE';
export const ERROR_DELETE_SPACE = 'app/CirclePage/ERROR_DELETE_SPACE';
export const REQUEST_ADVANCED_SEARCH = 'app/CirclePage/REQUEST_ADVANCED_SEARCH';
export const SUCCESS_ADVANCED_SEARCH = 'app/CirclePage/SUCCESS_ADVANCED_SEARCH';
export const ERROR_ADVANCED_SEARCH = 'app/CirclePage/ERROR_ADVANCED_SEARCH';
export const REQUEST_EDIT_COMMENT = 'app/CirclePage/REQUEST_EDIT_COMMENT';
export const SUCCESS_EDIT_COMMENT = 'app/CirclePage/SUCCESS_EDIT_COMMENT';
export const ERROR_EDIT_COMMENT = 'app/CirclePage/ERROR_EDIT_COMMENT';
export const REQUEST_DELETE_POST = 'app/CirclePage/REQUEST_DELETE_POST';
export const SUCCESS_DELETE_POST = 'app/CirclePage/SUCCESS_DELETE_POST';
export const ERROR_DELETE_POST = 'app/CirclePage/ERROR_DELETE_POST';
export const REQUEST_FOLLOW_POST = 'app/CirclePage/REQUEST_FOLLOW_POST';
export const SUCCESS_FOLLOW_POST = 'app/CirclePage/SUCCESS_FOLLOW_POST';
export const ERROR_FOLLOW_POST = 'app/CirclePage/ERROR_FOLLOW_POST';
export const REQUEST_FLAGGED_CONTENT = 'app/CirclePage/REQUEST_FLAGGED_CONTENT';
export const SUCCESS_FLAGGED_CONTENT = 'app/CirclePage/SUCCESS_FLAGGED_CONTENT';
export const ERROR_FLAGGED_CONTENT = 'app/CirclePage/ERROR_FLAGGED_CONTENT';
export const REQUEST_SPACE_TOPICS = 'app/CirclePage/REQUEST_SPACE_TOPICS';
export const SUCCESS_SPACE_TOPICS = 'app/CirclePage/SUCCESS_SPACE_TOPICS';
export const ERROR_SPACE_TOPICS = 'app/CirclePage/ERROR_SPACE_TOPICS';
export const CLEAR_SPACE_TOPICS = 'app/CirclePage/CLEAR_SPACE_TOPICS';
export const REQUEST_COMMENT_REPLIES = 'app/CirclePage/REQUEST_COMMENT_REPLIES';
export const SUCCESS_COMMENT_REPLIES = 'app/CirclePage/SUCCESS_COMMENT_REPLIES';
export const ERROR_COMMENT_REPLIES = 'app/CirclePage/ERROR_COMMENT_REPLIES';

export const TOGGEL_SEARCH_IN_GROUP = 'app/CirclePage/TOGGEL_SEARCH_IN_GROUP'
export const SET_ACTIVE_TAB = 'app/CirclePage/SET_ACTIVE_TAB';
export const TOGGLE_GIPHY = 'app/CirclePage/TOGGLE_GIPHY';
export const TOGGLE_DOCUMENT_MODAL = 'app/CirclePage/TOGGLE_DOCUMENT_MODAL';
export const TOGGLE_COVER_IMAGE_MODAL = 'app/CirclePage/TOGGLE_COVER_IMAGE_MODAL';
export const TOGGLE_IMAGE_MODAL = 'app/CirclePage/TOGGLE_IMAGE_MODAL';
export const TOGGLE_VIDEO_UPLOAD = 'app/CirclePage/TOGGLE_VIDEO_UPLOAD';
export const TOGGLE_REQUEST_SPACE = 'app/CirclePage/TOGGLE_REQUEST_SPACE';
export const TOGGLE_SEEALL_GROUP = 'app/CirclePage/TOGGLE_SEEALL_GROUP';
export const TOGGLE_EDIT_COMMENT = 'app/CirclePage/TOGGLE_EDIT_COMMENT';
export const TOGGLE_EMOJI = 'app/CirclePage/TOGGLE_EMOJI';
export const TOGGLE_CREATE_POST = 'app/CirclePage/TOGGLE_CREATE_POST';
export const ON_EDIT_POST = 'app/CirclePage/ON_EDIT_POST';
export const TOGGLE_REPORT_CONTENT = 'app/CirclePage/TOGGLE_REPORT_CONTENT';
export const TOGGLE_REPLY_GIPHY = 'app/CirclePage/TOGGLE_REPLY_';
export const TOGGLE_DOCUMENT_REPLY_MODAL = 'app/CirclePage/TOGGLE_DOCUMENT_REPLY_MODAL';
export const TOGGLE_IMAGE_REPLY_MODAL = 'app/CirclePage/TOGGLE_IMAGE_REPLY_MODAL';
export const TOGGLE_VIDEO_REPLY_UPLOAD = 'app/CirclePage/TOGGLE_VIDEO_REPLY_UPLOAD';
export const TOGGLE_REPLY_EMOJI = 'app/CirclePage/TOGGLE_REPLY_EMOJI';
export const REQUEST_NOTIFICATIONS = 'app/CirclePage/REQUEST_NOTIFICATIONS';
export const SUCCESS_NOTIFICATIONS = 'app/CirclePage/SUCCESS_NOTIFICATIONS';
export const ERROR_NOTIFICATIONS = 'app/CirclePage/ERROR_NOTIFICATIONS';
export const REQUEST_NOTIFICATION_COUNT = 'app/CirclePage/REQUEST_NOTIFICATION_COUNT';
export const SUCCESS_NOTIFICATION_COUNT = 'app/CirclePage/SUCCESS_NOTIFICATION_COUNT';
export const ERROR_NOTIFICATION_COUNT = 'app/CirclePage/ERROR_NOTIFICATION_COUNT';
export const REQUEST_MARK_AS_READ = 'app/CirclePage/REQUEST_MARK_AS_READ';
export const SUCCESS_MARK_AS_READ = 'app/CirclePage/SUCCESS_MARK_AS_READ';
export const ERROR_MARK_AS_READ = 'app/CirclePage/ERROR_MARK_AS_READ';
export const REQUEST_RESET_NOTIFICATIONS = 'app/CirclePage/REQUEST_RESET_NOTIFICATIONS';
export const SUCCESS_RESET_NOTIFICATIONS = 'app/CirclePage/SUCCESS_RESET_NOTIFICATIONS';
export const ERROR_RESET_NOTIFICATIONS = 'app/CirclePage/ERROR_RESET_NOTIFICATIONS';
export const REQUEST_MEMBER_DETAIL = 'app/CirclePage/REQUEST_MEMBER_DETAIL';
export const SUCCESS_MEMBER_DETAIL = 'app/CirclePage/SUCCESS_MEMBER_DETAIL';
export const ERROR_MEMBER_DETAIL = 'app/CirclePage/ERROR_MEMBER_DETAIL';
export const TOGGLE_IS_REPLY = 'app/CirclePage/TOGGLE_IS_REPLY';
export const TOGGLE_IS_ADD_COMMENT = 'app/CirclePage/TOGGLE_IS_ADD_COMMENT';
export const REQUEST_DELETE_REPLY = 'app/CirclePage/REQUEST_DELETE_REPLY';
export const SUCCESS_DELETE_REPLY = 'app/CirclePage/SUCCESS_DELETE_REPLY';
export const ERROR_DELETE_REPLY = 'app/CirclePage/ERROR_DELETE_REPLY';
export const REQUEST_ADD_MEMBER = 'app/CirclePage/REQUEST_ADD_MEMBER';
export const SUCCESS_ADD_MEMBER = 'app/CirclePage/SUCCESS_ADD_MEMBER';
export const ERROR_ADD_MEMBER = 'app/CirclePage/ERROR_ADD_MEMBER';
export const REQUEST_SPACE_MEMBER_FULL_LIST = 'app/CirclePage/REQUEST_SPACE_MEMBER_FULL_LIST';
export const REQUEST_MARKALL_NOTIFICATIONS_AS_READ = 'app/CirclePage/REQUEST_MARKALL_NOTIFICATIONS_AS_READ';
export const SUCCESS_MARKALL_NOTIFICATIONS_AS_READ = 'app/CirclePage/SUCCESS_MARKALL_NOTIFICATIONS_AS_READ';
export const ERROR_MARKALL_NOTIFICATIONS_AS_READ = 'app/CirclePage/ERROR_MARKALL_NOTIFICATIONS_AS_READ';
export const REQUEST_NOTIFICATION_PREFERENCES = 'app/CirclePage/REQUEST_NOTIFICATION_PREFERENCES';
export const SUCCESS_NOTIFICATION_PREFERENCES = 'app/CirclePage/SUCCESS_NOTIFICATION_PREFERENCES';
export const ERROR_NOTIFICATION_PREFERENCES = 'app/CirclePage/ERROR_NOTIFICATION_PREFERENCES';
export const REQUEST_GROUP_POST_SEARCH = 'app/CirclePage/REQUEST_GROUP_POST_SEARCH';
export const SUCCESS_GROUP_POST_SEARCH = 'app/CirclePage/SUCCESS_GROUP_POST_SEARCH';
export const ERROR_GROUP_POST_SEARCH = 'app/CirclePage/ERROR_GROUP_POST_SEARCH';

export const FETCH_USER_ACTIVITY_REQUEST = 'app/CirclePage/FETCH_USER_ACTIVITY_REQUEST';
export const FETCH_USER_ACTIVITY_SUCCESS = 'app/CirclePage/FETCH_USER_ACTIVITY_SUCCESS';
export const FETCH_USER_ACTIVITY_ERROR = 'app/CirclePage/FETCH_USER_ACTIVITY_ERROR';
export const TOGGEL_DOCUMENT_DROPDOWN = 'app/CirclePage/TOGGEL_DOCUMENT_DROPDOWN';
export const TOGGEL_ADD_DOCUMENT = 'app/CirclePage/TOGGEL_ADD_DOCUMENT';
export const TOGGEL_ADD_FOLDER = 'app/CirclePage/TOGGEL_ADD_FOLDER';
export const TOGGEL_FOLDER_DOCUMENT = 'app/CirclePage/TOGGEL_FOLDER_DOCUMENT';

export const UPLOAD_DOCUMENT_REQUEST = 'app/CirclePage/UPLOAD_DOCUMENT_REQUEST';
export const UPLOAD_DOCUMENT_SUCCESS = 'app/CirclePage/UPLOAD_DOCUMENT_SUCCESS';
export const UPLOAD_DOCUMENT_ERROR = 'app/CirclePage/UPLOAD_DOCUMENT_ERROR';

const initialState = {
  isDropdownDocument: false,
  isAddDocument: false,
  isAddFolder: false,
  isFolderDocument:null,
  isSearchInModal : false,
  isSpaceMemberListRequested: false,
  isSpaceMemberListRequested: false,
  isReplyComment: null,
  isAddComment: false,
  activeTab: null,
  isGiphyOpen: false,
  isDocumentModal: false,
  isImageModal: false,
  isCoverImageModal: false,
  isVideoUpload: false,
  isRequestSpace: false,
  isSeeAllGroup: false,
  isEmojiOpen: false,
  isCreatePost: false,
  isReportModal: null,
  editPostData: null,
  editCommentData: null,
  accessToken: null,
  requestAccessToken: false,
  errorAccessToken: null,
  requestHomePage: false,
  loadMoreHomePage: false,
  homePageData: null,
  errorHomePage: null,
  requestCreatePost: false,
  createPostData: null,
  errorCreatePost: null,
  requestLikePost: false,
  likePostData: null,
  errorLikePost: null,
  requestCreateComment: false,
  createCommentData: null,
  errorCreateComment: null,
  requestDeleteComment: false,
  deleteCommentData: null,
  errorDeleteComment: null,
  currentCommunityMember: null,
  requestCommunityMember: false,
  errorCommunityMember: null,
  requestSpaceList: false,
  spaceListData: [],
  errorSpaceList: null,
  requestSpaceListV2: false,
  spaceListDataV2: [],
  errorSpaceListV2: null,
  requestCreateUser: false,
  circleNewUser: null,
  errorCreateUser: null,
  requestDirectUpload: false,
  directUploadData: null,
  errorDirectUpload: null,
  requestNewSpace: false,
  newSpaceData: null,
  errorNewSpace: null,
  requestJoinSpace: false,
  joinSpaceData: null,
  errorJoinSpace: null,
  requestCombineSpaceTopics: false,
  combineSpaceTopicsData: null,
  errorCombineSpaceTopics: null,
  requestLeaveSpace: false,
  leaveSpaceData: null,
  errorLeaveSpace: null,
  requestCreateBookmark: false,
  createBookmarkData: null,
  errorCreateBookmark: null,
  requestDeleteBookmark: false,
  deleteBookmarkData: null,
  errorDeleteBookmark: null,
  requestBookmarksList: false,
  bookmarksListData: null,
  errorBookmarksList: null,
  requestSinglePost: false,
  singlePostData: null,
  errorSinglePost: null,
  requestPostCommentList: false,
  loadMoreComments: false,
  postCommentListData: null,
  errorPostCommentList: null,
  requestLikeDislikeComment: false,
  likeDislikeCommentData: null,
  errorLikeDislikeComment: null,
  requestCreateReplyComment: false,
  createReplyCommentData: null,
  errorCreateReplyComment: null,
  requestSpaceDetails: false,
  spaceDetailsData: null,
  errorSpaceDetails: null,
  requestTopicDetails: false,
  topicDetailsData: null,
  errorTopicDetails: null,
  requestSpaceMembers: false,
  spaceMembersData: null,
  spaceMembersFullListData: null,
  errorSpaceMembers: null,
  requestRemoveSpaceMember: false,
  removeSpaceMemberData: null,
  errorRemoveSpaceMember: null,
  requestDeleteSpace: false,
  deleteSpaceData: null,
  errorDeleteSpace: null,
  requestAdvancedSearch: false,
  advancedSearchData: null,
  errorAdvancedSearch: null,
  requestEditComment: false,
  editCommentData: null,
  errorEditComment: null,
  requestDeletePost: null,
  errorDeletePost: null,
  requestFollowPost: null,
  errorFollowPost: null,
  requestFlaggedContent: false,
  flaggedContentData: null,
  errorFlaggedContent: null,
  isReplyGiphyOpen: false,
  isReplyDocumentModal: false,
  isReplyImageModal: false,
  isReplyVideoUpload: false,
  isReplyEmojiOpen: false,
  requestSpaceTopics: false,
  spaceTopicsData: null,
  errorSpaceTopics: null,
  requestNotificationsInProgress: false,
  notificationsData: null,
  errorNotifications: null,
  requestNotificationCountInProgress: false,
  notificationCountData: null,
  errorNotificationCount: null,
  requestMarkAsReadInProgress: false,
  markAsReadData: null,
  errorMarkAsRead: null,
  requestResetNotificationsInProgress: false,
  resetNotificationsData: null,
  errorResetNotifications: null,
  requestMemberDetail: false,
  memberDetailData: null,
  errorMemberDetail: null,
  loadCommentReplyInProgress: false,
  loadCommentReplyError: null,
  isDeleteReplyInProgress: false,
  deleteReplyData: null,
  isDeleteReplyError: null,
  requestMarkAllNotificationsAsRead: false,
  errorMarkAllNotificationsAsRead: null,
  requestNotificationPreferenceInProgress: false,
  requestChangeNotificationPreference: false,
  notificaitonPreferenceData: {},
  errorNotificationPreference: null,
  requestAddMemberInProgress: false,
  requestAddMemberError: null,
  alreadyAdded:null,
  groupPostSearchInProgress: false,
  groupPostSearchLoadMore:false,
  groupPostSearchError: null,
  groupPostSearchData: null,
  fetchUserActivityRequest:false,
  fetchUserActivityData:null,
  fetchUserActivityError:null,

  uploadInProgress: false,
  uploadedDocument: null,
  uploadError: null,
};

export default function circlePageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case TOGGEL_SEARCH_IN_GROUP:
      return { ...state, isSearchInModal: payload.data, groupPostSearchData: null };
    case REQUEST_SPACE_MEMBER_FULL_LIST:
      return { ...state, isSpaceMemberListRequested: payload.data };
    case TOGGLE_GIPHY:
      return { ...state, isGiphyOpen: !state.isGiphyOpen };
    case TOGGLE_DOCUMENT_MODAL:
      return { ...state, isDocumentModal: !state.isDocumentModal };
    case TOGGLE_IMAGE_MODAL:
      return { ...state, isImageModal: !state.isImageModal };
    case TOGGLE_COVER_IMAGE_MODAL:
      return { ...state, isCoverImageModal: !state.isCoverImageModal };
    case TOGGLE_VIDEO_UPLOAD:
      return { ...state, isVideoUpload: !state.isVideoUpload };
    case TOGGLE_REQUEST_SPACE:
      return { ...state, isRequestSpace: payload.data };
    case TOGGLE_SEEALL_GROUP:
      return { ...state, isSeeAllGroup: !state.isSeeAllGroup };
    case TOGGLE_EDIT_COMMENT:
      return { ...state, editCommentData: state.editCommentData ? null : payload.data };
    case TOGGLE_EMOJI:
      return { ...state, isEmojiOpen: payload.data };
    case TOGGLE_CREATE_POST:
      return { ...state, isCreatePost: !state.isCreatePost };
    case ON_EDIT_POST:
      return { ...state, editPostData: payload.data };
    case TOGGLE_REPORT_CONTENT:
      return { ...state, isReportModal: state.isReportModal ? null : payload.postId };

    case TOGGLE_REPLY_GIPHY:
      return { ...state, isReplyGiphyOpen: !state.isReplyGiphyOpen };
    case TOGGLE_DOCUMENT_REPLY_MODAL:
      return { ...state, isReplyDocumentModal: !state.isReplyDocumentModal };
    case TOGGLE_IMAGE_REPLY_MODAL:
      return { ...state, isReplyImageModal: !state.isReplyImageModal };
    case TOGGLE_VIDEO_REPLY_UPLOAD:
      return { ...state, isReplyVideoUpload: !state.isReplyVideoUpload };
    case TOGGLE_REPLY_EMOJI:
      return { ...state, isReplyEmojiOpen: payload.data };
    case TOGGLE_IS_REPLY:
      return { ...state, isReplyComment: payload.data };
    case TOGGLE_IS_ADD_COMMENT:
      return { ...state, isAddComment: payload.data };

    case SET_INITIAL_STATE:
      return { ...initialState };
    case REQUEST_ACCESS_TOKEN:
      return { ...state, requestAccessToken: true };
    case SUCCESS_ACCESS_TOKEN:
      return { ...state, requestAccessToken: false, accessToken: payload.data };
    case ERROR_ACCESS_TOKEN:
      return {
        ...state,
        requestAccessToken: false,
        accessToken: null,
        errorAccessToken: payload.error,
      };
    case REQUEST_HOME_PAGE:
      return { ...state, requestHomePage: payload.page <= 1, loadMoreHomePage: payload.page > 1 };
    case SUCCESS_HOME_PAGE:
      const { data } = payload;
      const { page, records } = data;
      return {
        ...state,
        requestHomePage: false,
        loadMoreHomePage: false,
        homePageData: {
          ...data,
          records:
            page > 1
              ? (() => {
                  //remove first 20 records to reduce page load
                  const updatedRecords = [...state.homePageData.records, ...records];
                  return updatedRecords.length >= recordLimit
                    ? updatedRecords.slice(20)
                    : updatedRecords;
                })()
              : records,
        },
      };

    case ERROR_HOME_PAGE:
      return {
        ...state,
        requestHomePage: false,
        loadMoreHomePage: false,
        errorHomePage: payload.error,
      };
    case REQUEST_CREATE_POST:
      return { ...state, requestCreatePost: true };
    case SUCCESS_CREATE_POST:
      state.spaceDetailsData?.postResponse?.records;
      return {
        ...state,
        requestCreatePost: false, //createPostData: payload.data
        homePageData: {
          ...state.homePageData,
          records: state.homePageData.records.some(record => record.id === payload.data.id)
            ? state.homePageData.records.map(record =>
                record.id === payload.data.id ? payload.data : record
              )
            : [payload.data, ...state.homePageData.records],
        },
        spaceDetailsData: {
          ...state.spaceDetailsData,
          postResponse: {
            ...state.spaceDetailsData?.postResponse,
            records: (state.spaceDetailsData?.postResponse?.records || []).some(
              record => record.id === payload.data.id
            )
              ? (state.spaceDetailsData?.postResponse?.records || []).map(record =>
                  record.id === payload.data.id ? payload.data : record
                )
              : [payload.data, ...(state.spaceDetailsData?.postResponse?.records || [])],
          },
        },
      };
    case ERROR_CREATE_POST:
      return {
        ...state,
        requestCreatePost: false,
        createPostData: null,
        errorCreatePost: payload.error,
      };
    case REQUEST_LIKE_DISLIKE_POST:
      const updatedRecords =
        state?.homePageData?.records?.map(item =>
          item?.id === payload.postId
            ? {
                ...item,
                is_liked: !item.is_liked,
                user_likes_count: item.is_liked
                  ? item.user_likes_count - 1
                  : item.user_likes_count + 1,
              }
            : item
        ) || [];
      const updatedSpaceRecords =
        state?.spaceDetailsData?.postResponse?.records?.map(item =>
          item?.id === payload.postId
            ? {
                ...item,
                is_liked: !item.is_liked,
                user_likes_count: item.is_liked
                  ? item.user_likes_count - 1
                  : item.user_likes_count + 1,
              }
            : item
        ) || [];
      return {
        ...state,
        requestLikePost: true,
        homePageData: {
          ...state.homePageData,
          records: updatedRecords,
        },
        spaceDetailsData: {
          ...state.spaceDetailsData,
          postResponse: {
            ...state?.spaceDetailsData?.postResponse,
            records: updatedSpaceRecords,
          },
        },
      };
    case SUCCESS_LIKE_DISLIKE_POST:
      return { ...state, requestLikePost: false, likePostData: payload.data };
    case ERROR_LIKE_DISLIKE_POST:
      const revertedRecords =
        state?.homePageData?.records?.map(item =>
          item?.id === payload.postId
            ? {
                ...item,
                is_liked: !item.is_liked,
                user_likes_count: item.is_liked
                  ? item.user_likes_count - 1
                  : item.user_likes_count + 1,
              }
            : item
        ) || [];
      const revertSpaceRecords =
        state?.spaceDetailsData?.postResponse?.records?.map(item =>
          item?.id === payload.postId
            ? {
                ...item,
                is_liked: !item.is_liked,
                user_likes_count: item.is_liked
                  ? item.user_likes_count - 1
                  : item.user_likes_count + 1,
              }
            : item
        ) || [];
      return {
        ...state,
        requestLikePost: false,
        likePostData: null,
        errorLikePost: payload.error,
        homePageData: {
          ...state.homePageData,
          records: revertedRecords,
        },
        spaceDetailsData: {
          ...state.spaceDetailsData,
          postResponse: {
            ...state?.spaceDetailsData?.postResponse,
            records: revertSpaceRecords,
          },
        },
      };
    case REQUEST_CREATE_COMMENT:
      return { ...state, requestCreateComment: true };
    case SUCCESS_CREATE_COMMENT:
      const newComment = payload.data;
      const existingCommentIndex = state.postCommentListData.records.findIndex(
        item => item.id === newComment.id
      );
      return {
        ...state,
        requestCreateComment: false,
        createCommentData: payload.data,
        postCommentListData: {
          ...state.postCommentListData,
          records:
            existingCommentIndex !== -1
              ? state.postCommentListData.records.map((item, index) =>
                  index === existingCommentIndex ? newComment : item
                )
              : [...state.postCommentListData.records, newComment],
        },
        homePageData: {
          ...state.homePageData,
          records: state?.homePageData?.records?.map(item =>
            item.id === payload.data.post_id
              ? {
                  ...item,
                  comment_count:
                    existingCommentIndex === -1 ? item.comment_count + 1 : item.comment_count,
                }
              : item
          ),
        },
        spaceDetailsData: {
          ...state.spaceDetailsData,
          postResponse: {
            ...state?.spaceDetailsData?.postResponse,
            records: state?.spaceDetailsData?.postResponse?.records?.map(item =>
              item.id === payload.data.post_id
                ? {
                    ...item,
                    comment_count:
                      existingCommentIndex === -1 ? item.comment_count + 1 : item.comment_count,
                  }
                : item
            ),
          },
        },
      };
    case ERROR_CREATE_COMMENT:
      return {
        ...state,
        requestCreateComment: false,
        createCommentData: null,
        errorCreateComment: payload.error,
      };
    case REQUEST_DELETE_COMMENT:
      return { ...state, requestDeleteComment: true };
    case SUCCESS_DELETE_COMMENT:
      return {
        ...state,
        requestDeleteComment: false,
        deleteCommentData: payload.data,
        postCommentListData: {
          ...state.postCommentListData,
          records: state.postCommentListData.records.filter(item => item.id !== payload.commentId),
        },
        homePageData: {
          ...state.homePageData,
          records: state?.homePageData?.records?.map(item =>
            item.id === payload.commentId
              ? { ...item, comment_count: item.comment_count - 1 }
              : item
          ),
        },
        spaceDetailsData: {
          ...state.spaceDetailsData,
          postResponse: {
            ...state?.spaceDetailsData?.postResponse,
            records: state?.spaceDetailsData?.postResponse?.records?.map(item =>
              item.id === payload.commentId
                ? { ...item, comment_count: item.comment_count - 1 }
                : item
            ),
          },
        },
      };
    case ERROR_DELETE_COMMENT:
      return {
        ...state,
        requestDeleteComment: false,
        deleteCommentData: null,
        errorDeleteComment: payload.error,
      };
    case REQUEST_COMMUNITY_MEMBER:
      return { ...state, requestCommunityMember: true };
    case SUCCESS_COMMUNITY_MEMBER:
      return { ...state, requestCommunityMember: false, currentCommunityMember: payload.data };
    case ERROR_COMMUNITY_MEMBER:
      return {
        ...state,
        requestCommunityMember: false,
        currentCommunityMember: null,
        errorCommunityMember: payload.error,
      };
    case REQUEST_SPACE_LIST:
      return { ...state, requestSpaceList: true };
    case SUCCESS_SPACE_LIST:
      return { ...state, requestSpaceList: false, spaceListData: payload.data };
    case ERROR_SPACE_LIST:
      return {
        ...state,
        requestSpaceList: false,
        errorSpaceList: payload.error,
      };
    case REQUEST_SPACE_LISTV2:
      return { ...state, requestSpaceListV2: true };
    case SUCCESS_SPACE_LISTV2:
      return { ...state, requestSpaceListV2: false, spaceListDataV2: payload.data };
    case ERROR_SPACE_LISTV2:
      return {
        ...state,
        requestSpaceListV2: false,
        errorSpaceListV2: payload.error,
      };
    case REQUEST_CREATE_USER:
      return { ...state, requestCreateUser: true };
    case SUCCESS_CREATE_USER:
      return { ...state, requestCreateUser: false, circleNewUser: payload.data };
    case ERROR_CREATE_USER:
      return {
        ...state,
        requestCreateUser: false,
        circleNewUser: null,
        errorCreateUser: payload.error,
      };
    case REQUEST_DIRECT_UPLOAD:
      return { ...state, requestDirectUpload: true };
    case SUCCESS_DIRECT_UPLOAD:
      return { ...state, requestDirectUpload: false, directUploadData: payload.data };
    case ERROR_DIRECT_UPLOAD:
      return {
        ...state,
        requestDirectUpload: false,
        directUploadData: null,
        errorDirectUpload: payload.error,
      };
    case REQUEST_NEW_SPACE:
      return { ...state, requestNewSpace: true };
    case SUCCESS_NEW_SPACE:
      return { ...state, requestNewSpace: false, newSpaceData: payload.data };
    case ERROR_NEW_SPACE:
      return {
        ...state,
        requestNewSpace: false,
        newSpaceData: null,
        errorNewSpace: payload.error,
      };
    case REQUEST_JOIN_SPACE:
      return { ...state, requestJoinSpace: true };

    case SUCCESS_JOIN_SPACE:
      return {
        ...state,
        requestJoinSpace: false,
        joinSpaceData: payload.data,
        spaceListData: state.spaceListData.map(item =>
          item.id === payload.data.id ? { ...item, ...payload.data } : item
        ),
      };
    case ERROR_JOIN_SPACE:
      return {
        ...state,
        requestJoinSpace: false,
        joinSpaceData: null,
        errorJoinSpace: payload.error,
      };
    case REQUEST_COMBINE_SPACE_TOPICS:
      return { ...state, requestCombineSpaceTopics: true };
    case SUCCESS_COMBINE_SPACE_TOPICS:
      return { ...state, requestCombineSpaceTopics: false, combineSpaceTopicsData: payload.data };
    case ERROR_COMBINE_SPACE_TOPICS:
      return {
        ...state,
        requestCombineSpaceTopics: false,
        combineSpaceTopicsData: null,
        errorCombineSpaceTopics: payload.error,
      };
    case REQUEST_LEAVE_SPACE:
      return { ...state, requestLeaveSpace: true };
    case SUCCESS_LEAVE_SPACE:
      return {
        ...state,
        requestLeaveSpace: false,
        leaveSpaceData: payload.data,
        spaceListData: state.spaceListData.map(
          item =>
            item.id === payload.data.id
              ? { ...item, ...payload.data } // Replace with updated data
              : item // Keep the existing item
        ),
      };
    case ERROR_LEAVE_SPACE:
      return {
        ...state,
        requestLeaveSpace: false,
        leaveSpaceData: null,
        errorLeaveSpace: payload.error,
      };
    case REQUEST_CREATE_BOOKMARK:
      const createSpaceBookmarks =
        state?.spaceDetailsData?.postResponse?.records?.map(item =>
          item?.id === payload.postId
            ? {
                ...item,
                bookmark_id: !item.bookmark_id,
              }
            : item
        ) || [];
      return {
        ...state,
        requestCreateBookmark: true,
        homePageData: {
          ...state.homePageData,
          records:
            state?.homePageData?.records?.map(item =>
              item?.id === payload.postId
                ? {
                    ...item,
                    bookmark_id: !item.bookmark_id,
                  }
                : item
            ) || [],
        },
        spaceDetailsData: {
          ...state.spaceDetailsData,
          postResponse: {
            ...state?.spaceDetailsData?.postResponse,
            records: createSpaceBookmarks,
          },
        },
      };
    case SUCCESS_CREATE_BOOKMARK:
      return { ...state, requestCreateBookmark: false, createBookmarkData: payload.data };
    case ERROR_CREATE_BOOKMARK:
      return {
        ...state,
        requestCreateBookmark: false,
        createBookmarkData: null,
        errorCreateBookmark: payload.error,
        homePageData: {
          ...state.homePageData,
          records:
            state?.homePageData?.records?.map(item =>
              item?.id === payload.postId
                ? {
                    ...item,
                    bookmark_id: !item.bookmark_id,
                  }
                : item
            ) || [],
        },
      };
    case REQUEST_DELETE_BOOKMARK:
      const deleteSpaceBookmarks =
        state?.spaceDetailsData?.postResponse?.records?.map(item =>
          item?.id === payload.postId
            ? {
                ...item,
                bookmark_id: !item.bookmark_id,
              }
            : item
        ) || [];
      return {
        ...state,
        requestDeleteBookmark: true,
        homePageData: {
          ...state.homePageData,
          records:
            state?.homePageData?.records?.map(item =>
              item?.id === payload.postId
                ? {
                    ...item,
                    bookmark_id: !item.bookmark_id,
                  }
                : item
            ) || [],
        },
        spaceDetailsData: {
          ...state.spaceDetailsData,
          postResponse: {
            ...state?.spaceDetailsData?.postResponse,
            records: deleteSpaceBookmarks,
          },
        },
      };
    case SUCCESS_DELETE_BOOKMARK:
      return { ...state, requestDeleteBookmark: false, deleteBookmarkData: payload.data };
    case ERROR_DELETE_BOOKMARK:
      return {
        ...state,
        requestDeleteBookmark: false,
        deleteBookmarkData: null,
        errorDeleteBookmark: payload.error,
        homePageData: {
          ...state.homePageData,
          records:
            state?.homePageData?.records?.map(item =>
              item?.id === payload.postId
                ? {
                    ...item,
                    bookmark_id: !item.bookmark_id,
                  }
                : item
            ) || [],
        },
      };
    case REQUEST_BOOKMARKS_LIST:
      return { ...state, requestBookmarksList: true };
    case SUCCESS_BOOKMARKS_LIST:
      return { ...state, requestBookmarksList: false, bookmarksListData: payload.data };
    case ERROR_BOOKMARKS_LIST:
      return {
        ...state,
        requestBookmarksList: false,
        bookmarksListData: null,
        errorBookmarksList: payload.error,
      };
    case REQUEST_SINGLE_POST:
      return { ...state, requestSinglePost: true };
    case SUCCESS_SINGLE_POST:
      return {
        ...state,
        requestSinglePost: false,
        singlePostData: payload.data,
        // homePageData: {
        //   ...state.homePageData,
        //   records: state.homePageData.records.map(item =>
        //     resultIds({ data: [payload.data] }).includes(item.id)
        //       ? { ...item, ...payload.data }
        //       : item
        //   ),
        // },
        // bookmarksListData: {
        //   ...state.bookmarksListData,
        //   records: state.bookmarksListData.records.filter(
        //     item => item.record_id !== payload.data.id
        //   ),
        // },
      };
    case ERROR_SINGLE_POST:
      return {
        ...state,
        requestSinglePost: false,
        singlePostData: null,
        errorSinglePost: payload.error,
      };
    case REQUEST_POST_COMMENT_LIST:
      return {
        ...state,
        requestPostCommentList: payload.page === 1,
        loadMoreComments: payload.page > 1,
      };
    case SUCCESS_POST_COMMENT_LIST:
      return {
        ...state,
        requestPostCommentList: false,
        loadMoreComments: false,
        postCommentListData:
          payload.data.page > 1
            ? {
                ...state.postCommentListData,
                ...payload.data,
                records: [
                  ...state.postCommentListData.records.filter(
                    oldItem => !payload.data.records.some(newItem => newItem.id === oldItem.id)
                  ),
                  ...payload.data.records,
                ],
              }
            : {
                ...state.postCommentListData,
                ...payload.data,
              },
      };
    case ERROR_POST_COMMENT_LIST:
      return {
        ...state,
        requestPostCommentList: false,
        loadMoreComments: false,
        postCommentListData: null,
        errorPostCommentList: payload.error,
      };
    case REQUEST_LIKE_DISLIKE_COMMENT:
      return {
        ...state,
        requestLikeDislikeComment: true,
        postCommentListData: {
          ...state.postCommentListData,
          records: state.postCommentListData?.records.map(item =>
            item?.id === payload.commentId
              ? {
                  ...item,
                  is_liked: !item.is_liked,
                  user_likes_count: item.is_liked
                    ? item.user_likes_count - 1
                    : item.user_likes_count + 1,
                }
              : {
                  ...item,
                  replies: item?.replies?.map(reply =>
                    reply?.id === payload.commentId
                      ? {
                          ...reply,
                          is_liked: !reply.is_liked,
                          user_likes_count: reply.is_liked
                            ? reply.user_likes_count - 1
                            : reply.user_likes_count + 1,
                        }
                      : reply
                  ),
                }
          ),
        },
      };

    case SUCCESS_LIKE_DISLIKE_COMMENT:
      return { ...state, requestLikeDislikeComment: false, likeDislikeCommentData: payload.data };
    case ERROR_LIKE_DISLIKE_COMMENT:
      return {
        ...state,
        requestLikeDislikeComment: false,
        likeDislikeCommentData: null,
        errorLikeDislikeComment: payload.error,
      };
    case REQUEST_CREATE_REPLY_COMMENT:
      return { ...state, requestCreateReplyComment: true };
    case SUCCESS_CREATE_REPLY_COMMENT:
      return {
        ...state,
        requestCreateReplyComment: false,
        createReplyCommentData: payload.data,
        postCommentListData: {
          ...state.postCommentListData,
          records: state?.postCommentListData?.records?.map(item =>
            item.id === payload.data.parent_comment_id
              ? {
                  ...item,
                  replies: [...(item.replies || []), payload.data],
                }
              : item
          ),
        },
        homePageData: {
          ...state.homePageData,
          records: state?.homePageData?.records?.map(item =>
            item.id === payload.data.post_id
              ? { ...item, comment_count: item.comment_count + 1 }
              : item
          ),
        },
        spaceDetailsData: {
          ...state.spaceDetailsData,
          postResponse: {
            ...state?.spaceDetailsData?.postResponse,
            records: state?.spaceDetailsData?.postResponse?.records?.map(item =>
              item.id === payload.data.post_id
                ? { ...item, comment_count: item.comment_count + 1 }
                : item
            ),
          },
        },
      };
    case ERROR_CREATE_REPLY_COMMENT:
      return {
        ...state,
        requestCreateReplyComment: false,
        createReplyCommentData: null,
      };
    case REQUEST_SPACE_DETAILS:
      return {
        ...state,
        requestSpaceDetails: payload.page <= 1,
        loadMoreHomePage: payload.page > 1,
      };
    case SUCCESS_SPACE_DETAILS:
      return {
        ...state,
        requestSpaceDetails: false,
        loadMoreHomePage: false,
        spaceDetailsData: {
          ...payload.data,
          postResponse: {
            ...payload.data.postResponse,
            records:
              payload?.data?.postResponse?.page > 1
                ? (() => {
                    //remove first 20 records to reduce page load
                    const updatedRecords = [
                      ...state.spaceDetailsData?.postResponse?.records,
                      ...payload.data.postResponse?.records,
                    ];
                    return updatedRecords.length >= recordLimit
                      ? updatedRecords.slice(20)
                      : updatedRecords;
                  })()
                : payload.data.postResponse?.records,
          },
        },
      };
    case ERROR_SPACE_DETAILS:
      return {
        ...state,
        requestSpaceDetails: false,
        loadMoreHomePage: false,
        // spaceDetailsData: null,
        errorSpaceDetails: payload.error,
      };
    case REQUEST_TOPIC_DETAILS:
      return { ...state, requestTopicDetails: true };
    case SUCCESS_TOPIC_DETAILS:
      return {
        ...state,
        requestTopicDetails: false,
        topicDetailsData: payload.data,
        spaceDetailsData: { ...state.spaceDetailsData, postResponse: payload.data },
      };
    case ERROR_TOPIC_DETAILS:
      return {
        ...state,
        requestTopicDetails: false,
        topicDetailsData: null,
        errorTopicDetails: payload.error,
      };
    case REQUEST_SPACE_MEMBERS:
      return { ...state, requestSpaceMembers: true };
    case SUCCESS_SPACE_MEMBERS:
      return { ...state, requestSpaceMembers: false, spaceMembersData: payload.data };
    case SUCCESS_SPACE_MEMBER_FULL_LIST:
      return { ...state, requestSpaceMembers: false, spaceMembersFullListData: payload.data };
    case ERROR_SPACE_MEMBERS:
      return {
        ...state,
        requestSpaceMembers: false,
        spaceMembersData: null,
        errorSpaceMembers: payload.error,
      };
    case REQUEST_REMOVE_SPACE_MEMBER:
      return { ...state, requestRemoveSpaceMember: true };
    case SUCCESS_REMOVE_SPACE_MEMBER:
      return {
        ...state,
        requestRemoveSpaceMember: false,
        removeSpaceMemberData: payload.data,
        spaceMembersData: {
          ...state.spaceMembersData,
          records: state.spaceMembersData?.records?.filter(
            member => member.community_member_id !== payload.community_member_id
          ),
        },
        spaceMembersFullListData: {
          ...state.spaceMembersFullListData,
          records: state.spaceMembersFullListData?.records?.filter(
            member => member.community_member_id !== payload.community_member_id
          ),
        },
      };
    case ERROR_REMOVE_SPACE_MEMBER:
      return {
        ...state,
        requestRemoveSpaceMember: false,
        removeSpaceMemberData: null,
        errorRemoveSpaceMember: payload.error,
      };
    case REQUEST_DELETE_SPACE:
      return { ...state, requestDeleteSpace: true };
    case SUCCESS_DELETE_SPACE:
      return { ...state, requestDeleteSpace: false, deleteSpaceData: payload.data };
    case ERROR_DELETE_SPACE:
      return {
        ...state,
        requestDeleteSpace: false,
        deleteSpaceData: null,
        errorDeleteSpace: payload.error,
      };
    case REQUEST_ADVANCED_SEARCH:
      return { ...state, requestAdvancedSearch: true };
    case SUCCESS_ADVANCED_SEARCH:
      return { ...state, requestAdvancedSearch: false, advancedSearchData: payload.data };
    case ERROR_ADVANCED_SEARCH:
      return {
        ...state,
        requestAdvancedSearch: false,
        advancedSearchData: null,
        errorAdvancedSearch: payload.error,
      };
    case REQUEST_EDIT_COMMENT:
      return { ...state, requestEditComment: true };
    case SUCCESS_EDIT_COMMENT:
      return {
        ...state,
        requestEditComment: false,
        editCommentData: payload.data,
        postCommentListData: {
          ...state.postCommentListData,
          records: state?.postCommentListData?.records?.map(item =>
            item.id === payload.data.id ? { ...item, ...payload.data } : item
          ),
        },
      };
    case ERROR_EDIT_COMMENT:
      return {
        ...state,
        requestEditComment: false,
        editCommentData: null,
        errorEditComment: payload.error,
      };

    case REQUEST_DELETE_POST:
      return { ...state, requestDeletePost: payload.postId };
    case SUCCESS_DELETE_POST:
      return {
        ...state,
        requestDeletePost: null,
        homePageData: {
          ...state.homePageData,
          records: state.homePageData.records.filter(record => record.id !== payload.postId),
        },
        spaceDetailsData: {
          ...state.spaceDetailsData,
          postResponse: {
            ...state.spaceDetailsData?.postResponse,
            records:
              state.spaceDetailsData?.postResponse?.records?.filter(
                record => record.id !== payload.postId
              ) || [],
          },
        },
      };
    case ERROR_DELETE_POST:
      return {
        ...state,
        requestDeletePost: null,
        errorDeletePost: payload.error,
      };

    case REQUEST_FOLLOW_POST:
      return { ...state, requestDeletePost: payload.postId };
    case SUCCESS_FOLLOW_POST:
      return {
        ...state,
        requestDeletePost: null,
        homePageData: {
          ...state.homePageData,
          records: state.homePageData.records.some(record => record.id === payload.data.id)
            ? state.homePageData.records.map(record =>
                record.id === payload.data.id ? payload.data : record
              )
            : [payload.data, ...state.homePageData.records],
        },
        spaceDetailsData: {
          ...state.spaceDetailsData,
          postResponse: {
            ...state.spaceDetailsData?.postResponse,
            records: (state.spaceDetailsData?.postResponse?.records || []).some(
              record => record.id === payload.data.id
            )
              ? (state.spaceDetailsData?.postResponse?.records || []).map(record =>
                  record.id === payload.data.id ? payload.data : record
                )
              : [payload.data, ...(state.spaceDetailsData?.postResponse?.records || [])],
          },
        },
      };
    case ERROR_FOLLOW_POST:
      return {
        ...state,
        requestDeletePost: null,
        errorFollowPost: payload.error,
      };
    case REQUEST_FLAGGED_CONTENT:
      return { ...state, requestFlaggedContent: true };
    case SUCCESS_FLAGGED_CONTENT:
      return { ...state, requestFlaggedContent: false, flaggedContentData: payload.data };
    case ERROR_FLAGGED_CONTENT:
      return {
        ...state,
        requestFlaggedContent: false,
        flaggedContentData: null,
        errorFlaggedContent: payload.error,
      };
    case REQUEST_SPACE_TOPICS:
      return { ...state, requestSpaceTopics: true };
    case SUCCESS_SPACE_TOPICS:
      return { ...state, requestSpaceTopics: false, spaceTopicsData: payload.data };
    case ERROR_SPACE_TOPICS:
      return {
        ...state,
        requestSpaceTopics: false,
        spaceTopicsData: null,
        errorSpaceTopics: payload.error,
      };
    case CLEAR_SPACE_TOPICS: {
      return { ...state, spaceTopicsData: null };
    }
    case REQUEST_NOTIFICATIONS:
      return { ...state, requestNotificationsInProgress: true };
    case SUCCESS_NOTIFICATIONS:
      return { ...state, requestNotificationsInProgress: false, notificationsData: payload.data };
    case ERROR_NOTIFICATIONS:
      return {
        ...state,
        requestNotificationsInProgress: false,
        notificationsData: null,
        errorNotifications: payload.error,
      };
    case REQUEST_NOTIFICATION_COUNT:
      return { ...state, requestNotificationCountInProgress: true };
    case SUCCESS_NOTIFICATION_COUNT:
      return {
        ...state,
        requestNotificationCountInProgress: false,
        notificationCountData: payload.data,
      };
    case ERROR_NOTIFICATION_COUNT:
      return {
        ...state,
        requestNotificationCountInProgress: false,
        notificationCountData: null,
        errorNotificationCount: payload.error,
      };
    case REQUEST_MARK_AS_READ:
      return { ...state, requestMarkAsReadInProgress: true };
    case SUCCESS_MARK_AS_READ:
      return {
        ...state,
        requestMarkAsReadInProgress: false,
        markAsReadData: payload.data,
        notificationsData: {
          ...state.notificationsData,
          records: state?.notificationsData?.records?.map(item =>
            item.id === payload.data.id ? payload.data : item
          ),
        },
      };
    case ERROR_MARK_AS_READ:
      return {
        ...state,
        requestMarkAsReadInProgress: false,
        markAsReadData: null,
        errorMarkAsRead: payload.error,
      };
    case SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: payload.tab,
      };
    case REQUEST_RESET_NOTIFICATIONS:
      return { ...state, requestResetNotificationsInProgress: true };
    case SUCCESS_RESET_NOTIFICATIONS:
      return {
        ...state,
        requestResetNotificationsInProgress: false,
        resetNotificationsData: payload.data,
        notificationCountData: {
          ...state.notificationCountData,
          new_notifications_count: payload.data.new_notifications_count,
        },
      };
    case ERROR_RESET_NOTIFICATIONS:
      return {
        ...state,
        requestResetNotificationsInProgress: false,
        resetNotificationsData: null,
        errorResetNotifications: payload.error,
      };
    case REQUEST_MEMBER_DETAIL:
      return { ...state, requestMemberDetail: true };
    case SUCCESS_MEMBER_DETAIL:
      return { ...state, requestMemberDetail: false, memberDetailData: payload.data };
    case ERROR_MEMBER_DETAIL:
      return {
        ...state,
        requestMemberDetail: false,
        memberDetailData: null,
        errorMemberDetail: payload.error,
      };
    case REQUEST_COMMENT_REPLIES:
      return { ...state, loadCommentReplyInProgress: true };
    case SUCCESS_COMMENT_REPLIES:
      return {
        ...state,
        loadCommentReplyInProgress: false,
        postCommentListData: {
          ...state.postCommentListData,
          records: state.postCommentListData?.records.map(item =>
            item?.id === payload.commentId
              ? {
                  ...item,
                  loadMoreReplies: payload.data,
                  replies: [
                    ...item.replies,
                    ...payload.data.records.filter(
                      newReply =>
                        !item.replies.some(existingReply => existingReply.id === newReply.id)
                    ),
                  ],
                }
              : item
          ),
        },
      };
    case ERROR_COMMENT_REPLIES:
      return { ...state, loadCommentReplyError: payload.error, loadCommentReplyInProgress: false };
    case REQUEST_MARKALL_NOTIFICATIONS_AS_READ:
      return { ...state, requestMarkAllNotificationsAsRead: true };
    case SUCCESS_MARKALL_NOTIFICATIONS_AS_READ:
      return { ...state, requestMarkAllNotificationsAsRead: false };
    case ERROR_MARKALL_NOTIFICATIONS_AS_READ:
      return {
        ...state,
        requestMarkAllNotificationsAsRead: false,
        errorMarkAllNotificationsAsRead: payload.error,
      };
    case REQUEST_NOTIFICATION_PREFERENCES:
      return {
        ...state,
        requestNotificationPreferenceInProgress: true,
        errorNotificationPreference: null,
      };
    case SUCCESS_NOTIFICATION_PREFERENCES:
      return {
        ...state,
        requestNotificationPreferenceInProgress: false,
        notificaitonPreferenceData: payload.data,
      };
    case ERROR_NOTIFICATION_PREFERENCES:
      return {
        ...state,
        requestNotificationPreferenceInProgress: false,
        errorNotificationPreference: payload.error,
      };

    case REQUEST_ADD_MEMBER:
      return { ...state, requestAddMemberInProgress: true, requestAddMemberError: null };
    case SUCCESS_ADD_MEMBER:
      return { ...state, requestAddMemberInProgress: false, alreadyAdded: payload };
    case ERROR_ADD_MEMBER:
      return { ...state, requestAddMemberInProgress: false, requestAddMemberError: payload.error };
    case REQUEST_GROUP_POST_SEARCH:
      return {
        ...state,
        groupPostSearchInProgress: payload.page <= 1,
        groupPostSearchLoadMore: payload.page > 1,
        groupPostSearchError: null,
      };
    case SUCCESS_GROUP_POST_SEARCH:
      return {
        ...state,
        groupPostSearchInProgress: false,
        groupPostSearchLoadMore: false,
        groupPostSearchData:
          payload.data.page > 1
            ? {
                ...state.groupPostSearchData,
                records: [...state.groupPostSearchData.records, ...payload.data.records],
              }
            : payload.data,
      };
    case ERROR_GROUP_POST_SEARCH:
      return {
        ...state,
        groupPostSearchInProgress: false,
        groupPostSearchLoadMore: false,
        groupPostSearchError: payload.error,
      };

      case FETCH_USER_ACTIVITY_REQUEST:
        return {
          ...state,
          fetchUserActivityRequest:true,
          fetchUserActivityData:null,
          fetchUserActivityError:null
        };
      case FETCH_USER_ACTIVITY_SUCCESS:
        return {
          ...state,
          fetchUserActivityRequest:false,
          fetchUserActivityData:payload,
          fetchUserActivityError:null
        };
      case FETCH_USER_ACTIVITY_ERROR:
        return { ...state,
          fetchUserActivityRequest:false,
          fetchUserActivityData:null,
          fetchUserActivityError:true
        };
      case TOGGEL_DOCUMENT_DROPDOWN:
        return {
          ...state,
          isDropdownDocument:payload.data
      }
      case TOGGEL_ADD_DOCUMENT:
        return {
          ...state,
          isAddDocument:payload.data
      }

    case UPLOAD_DOCUMENT_REQUEST:
      return {
        ...state,
        uploadInProgress: true,
      };
    case UPLOAD_DOCUMENT_SUCCESS:
      return {
        ...state,
        uploadInProgress: false,
        uploadedDocument: payload,
        uploadError: null
      };
    case UPLOAD_DOCUMENT_ERROR:
      return {
        ...state,
        uploadInProgress: false,
        uploadedDocument: null,
        uploadError: payload
      };

      case TOGGEL_ADD_FOLDER:
        return {
          ...state,
          isAddFolder:payload.data
      }
      case TOGGEL_FOLDER_DOCUMENT:
        return {
          ...state,
          isFolderDocument:payload
      }
    default:
      return state;
  }
}

export const toggelDocumentDropdown = (data) => ({
  type: TOGGEL_DOCUMENT_DROPDOWN,
  payload: {data}
})

export const toggelAddDocument = (data) => ({
  type: TOGGEL_ADD_DOCUMENT,
  payload: {data}
})

export const toggelAddFolder = (data) => ({
  type: TOGGEL_ADD_FOLDER,
  payload: {data}
})

export const toggelFolderDocument = (data) => ({
  type: TOGGEL_FOLDER_DOCUMENT,
  payload: data
})

export const toggelSearchInSpace = (data) => ({
  type: TOGGEL_SEARCH_IN_GROUP,
  payload: {data}
})

export const toggleSpaceMemberList = (data) => ({
  type:REQUEST_SPACE_MEMBER_FULL_LIST,
  payload: {data}
})

export const setActiveTab = tab => ({
  type: SET_ACTIVE_TAB,
  payload: { tab },
})

export const toggleGiphy = () => ({
  type: TOGGLE_GIPHY,
});

export const toggleDocumentModal = () => ({
  type: TOGGLE_DOCUMENT_MODAL,
});

export const toggleCoverImageModal = () => ({
  type: TOGGLE_COVER_IMAGE_MODAL,
})

export const toggleImageModal = () => ({
  type: TOGGLE_IMAGE_MODAL,
});

export const toggleVideoUpload = () => ({
  type: TOGGLE_VIDEO_UPLOAD,
});

export const toggleRequestSpace = (data) => ({
  type: TOGGLE_REQUEST_SPACE,
  payload: { data },
});

export const toggleSeeAllGroup = () => ({
  type: TOGGLE_SEEALL_GROUP,
});

export const toggelEditComment = data => ({
  type: TOGGLE_EDIT_COMMENT,
  payload: { data },
});

export const toggleEmoji = (data) => ({
  type: TOGGLE_EMOJI,
  payload: { data },
});

export const toggleReplyComment = data => ({
  type: TOGGLE_IS_REPLY,
  payload: { data },
})

export const toggleCreateComment = (data) => ({
  type: TOGGLE_IS_ADD_COMMENT,
  payload: { data }
});

export const toggleCreatePost = () => ({
  type: TOGGLE_CREATE_POST,
});

export const toggleEditPost = data => ({
  type: ON_EDIT_POST,
  payload: { data },
});

export const toggleReportContent = postId => ({
  type: TOGGLE_REPORT_CONTENT,
  payload: { postId },
});

export const toggleReplyGiphy = () => ({
  type: TOGGLE_REPLY_GIPHY,
});

export const toggleReplyDocumentModal = () => ({
  type: TOGGLE_DOCUMENT_REPLY_MODAL,
});

export const toggleReplyImageModal = () => ({
  type: TOGGLE_IMAGE_REPLY_MODAL,
});

export const toggleReplyVideoUpload = () => ({
  type: TOGGLE_VIDEO_REPLY_UPLOAD,
});

export const toggleReplyEmoji = (data) => ({
  type: TOGGLE_REPLY_EMOJI,
  payload: { data },
});

export const setInitialValues = initialValues => ({
  type: SET_INITIAL_STATE,
  payload: pick(initialValues, Object.keys(initialState)),
});

export const requestAccessToken = () => ({
  type: REQUEST_ACCESS_TOKEN,
});
export const successAccessToken = data => ({
  type: SUCCESS_ACCESS_TOKEN,
  payload: { data },
});
export const errorAccessToken = error => ({
  type: ERROR_ACCESS_TOKEN,
  payload: { error },
});
export const requestHomePage = (page) => ({
  type: REQUEST_HOME_PAGE,
  payload: { page },
});
export const successHomePage = (data) => ({
  type: SUCCESS_HOME_PAGE,
  payload: { data },
});
export const errorHomePage = error => ({
  type: ERROR_HOME_PAGE,
  payload: { error },
});
export const requestCreatePost = () => ({
  type: REQUEST_CREATE_POST,
});
export const successCreatePost = data => ({
  type: SUCCESS_CREATE_POST,
  payload: { data },
});
export const errorCreatePost = error => ({
  type: ERROR_CREATE_POST,
  payload: { error },
});
export const requestLikeDislikePost = postId => ({
  type: REQUEST_LIKE_DISLIKE_POST,
  payload: { postId },
});
export const successLikeDislikePost = data => ({
  type: SUCCESS_LIKE_DISLIKE_POST,
  payload: { data },
});
export const errorLikeDislikePost = (postId, error) => ({
  type: ERROR_LIKE_DISLIKE_POST,
  payload: { postId, error },
});

export const requestCreateComment = () => ({
  type: REQUEST_CREATE_COMMENT,
});
export const successCreateComment = data => ({
  type: SUCCESS_CREATE_COMMENT,
  payload: { data },
});
export const errorCreateComment = error => ({
  type: ERROR_CREATE_COMMENT,
  payload: { error },
});

export const requestDeleteComment = () => ({
  type: REQUEST_DELETE_COMMENT,
});
export const successDeleteComment = (data, commentId) => ({
  type: SUCCESS_DELETE_COMMENT,
  payload: { data, commentId },
});
export const errorDeleteComment = error => ({
  type: ERROR_DELETE_COMMENT,
  payload: { error },
});

export const requestCommunityMember = () => ({
  type: REQUEST_COMMUNITY_MEMBER,
});
export const successCommunityMember = data => ({
  type: SUCCESS_COMMUNITY_MEMBER,
  payload: { data },
});
export const errorCommunityMember = error => ({
  type: ERROR_COMMUNITY_MEMBER,
  payload: { error },
});
export const requestSpaceList = () => ({
  type: REQUEST_SPACE_LIST,
});
export const successSpaceList = data => ({
  type: SUCCESS_SPACE_LIST,
  payload: { data },
});
export const errorSpaceList = error => ({
  type: ERROR_SPACE_LIST,
  payload: { error },
});
export const requestSpaceListV2 = () => ({
  type: REQUEST_SPACE_LISTV2,
});
export const successSpaceListV2 = data => ({
  type: SUCCESS_SPACE_LISTV2,
  payload: { data },
});
export const errorSpaceListV2 = error => ({
  type: ERROR_SPACE_LISTV2,
  payload: { error },
});
export const requestCreateUser = () => ({
  type: REQUEST_CREATE_USER,
});
export const successCreateUser = data => ({
  type: SUCCESS_CREATE_USER,
  payload: { data },
});
export const errorCreateUser = error => ({
  type: ERROR_CREATE_USER,
  payload: { error },
});

export const requestDirectUpload = () => ({
  type: REQUEST_DIRECT_UPLOAD,
});
export const successDirectUpload = data => ({
  type: SUCCESS_DIRECT_UPLOAD,
  payload: { data },
});
export const errorDirectUpload = error => ({
  type: ERROR_DIRECT_UPLOAD,
  payload: { error },
});

export const requestNewSpace = () => ({
  type: REQUEST_NEW_SPACE,
});
export const successNewSpace = data => ({
  type: SUCCESS_NEW_SPACE,
  payload: { data },
});
export const errorNewSpace = error => ({
  type: ERROR_NEW_SPACE,
  payload: { error },
});

export const requestJoinSpace = () => ({
  type: REQUEST_JOIN_SPACE,
});
export const successJoinSpace = data => ({
  type: SUCCESS_JOIN_SPACE,
  payload: { data },
});
export const errorJoinSpace = error => ({
  type: ERROR_JOIN_SPACE,
  payload: { error },
});

export const requestCombineSpaceTopics = () => ({
  type: REQUEST_COMBINE_SPACE_TOPICS,
});
export const successCombineSpaceTopics = data => ({
  type: SUCCESS_COMBINE_SPACE_TOPICS,
  payload: { data },
});
export const errorCombineSpaceTopics = error => ({
  type: ERROR_COMBINE_SPACE_TOPICS,
  payload: { error },
});

export const requestLeaveSpace = () => ({
  type: REQUEST_LEAVE_SPACE,
});
export const successLeaveSpace = data => ({
  type: SUCCESS_LEAVE_SPACE,
  payload: { data },
});
export const errorLeaveSpace = error => ({
  type: ERROR_LEAVE_SPACE,
  payload: { error },
});

export const requestCreateBookmark = postId => ({
  type: REQUEST_CREATE_BOOKMARK,
  payload: { postId },
});
export const successCreateBookmark = data => ({
  type: SUCCESS_CREATE_BOOKMARK,
  payload: { data },
});
export const errorCreateBookmark = error => ({
  type: ERROR_CREATE_BOOKMARK,
  payload: { postId, error },
});
export const requestDeleteBookmark = postId => ({
  type: REQUEST_DELETE_BOOKMARK,
  payload: { postId },
});
export const successDeleteBookmark = data => ({
  type: SUCCESS_DELETE_BOOKMARK,
  payload: { data },
});
export const errorDeleteBookmark = (postId, error) => ({
  type: ERROR_DELETE_BOOKMARK,
  payload: { postId, error },
});

export const requestBookmarksList = () => ({
  type: REQUEST_BOOKMARKS_LIST,
});
export const successBookmarksList = data => ({
  type: SUCCESS_BOOKMARKS_LIST,
  payload: { data },
});
export const errorBookmarksList = error => ({
  type: ERROR_BOOKMARKS_LIST,
  payload: { error },
});

export const requestSinglePost = () => ({
  type: REQUEST_SINGLE_POST,
});
export const successSinglePost = data => ({
  type: SUCCESS_SINGLE_POST,
  payload: { data },
});
export const errorSinglePost = error => ({
  type: ERROR_SINGLE_POST,
  payload: { error },
});
export const requestPostCommentList = (page) => ({
  type: REQUEST_POST_COMMENT_LIST,
  payload: { page },
});
export const successPostCommentList = (data, postId) => ({
  type: SUCCESS_POST_COMMENT_LIST,
  payload: { data, postId },
});
export const errorPostCommentList = error => ({
  type: ERROR_POST_COMMENT_LIST,
  payload: { error },
});

export const requestLikeDislikeComment = commentId => ({
  type: REQUEST_LIKE_DISLIKE_COMMENT,
  payload: { commentId },
});
export const successLikeDislikeComment = data => ({
  type: SUCCESS_LIKE_DISLIKE_COMMENT,
  payload: { data },
});
export const errorLikeDislikeComment = (commentId, error) => ({
  type: ERROR_LIKE_DISLIKE_COMMENT,
  payload: { commentId, error },
});

export const requestCommentReply = () => ({
  type: REQUEST_CREATE_REPLY_COMMENT,
});
export const successCommentReply = data => ({
  type: SUCCESS_CREATE_REPLY_COMMENT,
  payload: { data },
});
export const errorCommentReply = error => ({
  type: ERROR_CREATE_REPLY_COMMENT,
  payload: { error },
});

export const requestSpaceDetails = (page) => ({
  type: REQUEST_SPACE_DETAILS,
  payload: {page}
});
export const successSpaceDetails = data => ({
  type: SUCCESS_SPACE_DETAILS,
  payload: { data },
});
export const errorSpaceDetails = error => ({
  type: ERROR_SPACE_DETAILS,
  payload: { error },
});

export const requestTopicDetails = () => ({
  type: REQUEST_TOPIC_DETAILS,
});
export const successTopicDetails = data => ({
  type: SUCCESS_TOPIC_DETAILS,
  payload: { data },
});
export const errorTopicDetails = error => ({
  type: ERROR_TOPIC_DETAILS,
  payload: { error },
});

export const requestSpaceMembersList = () => ({
  type: REQUEST_SPACE_MEMBERS,
});
export const successSpaceMembersList = data => ({
  type: SUCCESS_SPACE_MEMBERS,
  payload: { data },
});
export const successSpaceMemberFullList = data => ({
  type: SUCCESS_SPACE_MEMBER_FULL_LIST,
  payload: { data },
});
export const errorSpaceMembersList = error => ({
  type: ERROR_SPACE_MEMBERS,
  payload: { error },
});

export const requestRemoveSpaceMember = () => ({
  type: REQUEST_REMOVE_SPACE_MEMBER,
});
export const successRemoveSpaceMember = (data, community_member_id) => ({
  type: SUCCESS_REMOVE_SPACE_MEMBER,
  payload: { data, community_member_id },
});
export const errorRemoveSpaceMember = error => ({
  type: ERROR_REMOVE_SPACE_MEMBER,
  payload: { error },
});
export const requestDeleteSpace = () => ({
  type: REQUEST_DELETE_SPACE,
});
export const successDeleteSpace = data => ({
  type: SUCCESS_DELETE_SPACE,
  payload: { data },
});
export const errorDeleteSpace = error => ({
  type: ERROR_DELETE_SPACE,
  payload: { error },
});

export const requestAdvancedSearch = () => ({
  type: REQUEST_ADVANCED_SEARCH,
});
export const successAdvancedSearch = data => ({
  type: SUCCESS_ADVANCED_SEARCH,
  payload: { data },
});
export const errorAdvancedSearch = error => ({
  type: ERROR_ADVANCED_SEARCH,
  payload: { error },
});

export const requestEditComment = () => ({
  type: REQUEST_EDIT_COMMENT,
});
export const successEditComment = data => ({
  type: SUCCESS_EDIT_COMMENT,
  payload: { data },
});
export const errorEditComment = error => ({
  type: ERROR_EDIT_COMMENT,
  payload: { error },
});

export const requestDeletePost = postId => ({
  type: REQUEST_DELETE_POST,
  payload: { postId },
});
export const successDeletePost = postId => ({
  type: SUCCESS_DELETE_POST,
  payload: { postId },
});
export const errorDeletePost = error => ({
  type: ERROR_DELETE_POST,
  payload: { error },
});

export const requestFollowPost = postId => ({
  type: REQUEST_FOLLOW_POST,
  payload: { postId },
});

export const successFollowPost = data => ({
  type: SUCCESS_FOLLOW_POST,
  payload: { data },
});

export const errorFollowPost = (postId, error) => ({
  type: ERROR_FOLLOW_POST,
  payload: { postId, error },
});

export const requestFlaggedContent = () => ({
  type: REQUEST_FLAGGED_CONTENT,
});
export const successFlaggedContent = data => ({
  type: SUCCESS_FLAGGED_CONTENT,
  payload: { data },
});
export const errorFlaggedContent = error => ({
  type: ERROR_FLAGGED_CONTENT,
  payload: { error },
});

export const requestSpaceTopics = () => ({
  type: REQUEST_SPACE_TOPICS,
});
export const successSpaceTopics = data => ({
  type: SUCCESS_SPACE_TOPICS,
  payload: { data },
});
export const errorSpaceTopics = error => ({
  type: ERROR_SPACE_TOPICS,
  payload: { error },
});
export const clearSpaceTopics = () => ({
  type: CLEAR_SPACE_TOPICS
})

export const requestNotifications = () => ({
  type: REQUEST_NOTIFICATIONS,
});
export const successNotifications = data => ({
  type: SUCCESS_NOTIFICATIONS,
  payload: { data },
});
export const errorNotifications = error => ({
  type: ERROR_NOTIFICATIONS,
  payload: { error },
});

export const requestNotificationCount = () => ({
  type: REQUEST_NOTIFICATION_COUNT,
});
export const successNotificationCount = data => ({
  type: SUCCESS_NOTIFICATION_COUNT,
  payload: { data },
});
export const errorNotificationCount = error => ({
  type: ERROR_NOTIFICATION_COUNT,
  payload: { error },
});

export const requestMarkAsRead = () => ({
  type: REQUEST_MARK_AS_READ,
});
export const successMarkAsRead = data => ({
  type: SUCCESS_MARK_AS_READ,
  payload: { data },
});
export const errorMarkAsRead = error => ({
  type: ERROR_MARK_AS_READ,
  payload: { error },
});

export const requestResetNotifications = () => ({
  type: REQUEST_RESET_NOTIFICATIONS,
});
export const successResetNotifications = data => ({
  type: SUCCESS_RESET_NOTIFICATIONS,
  payload: { data },
});
export const errorResetNotifications = error => ({
  type: ERROR_RESET_NOTIFICATIONS,
  payload: { error },
});

export const toggelGiphyReducer = () => (dispatch, getState, sdk) => {
  dispatch(toggleGiphy());
};

export const toggelDocumentReducer = () => (dispatch, getState, sdk) => {
  dispatch(toggleDocumentModal());
};

export const toggelCoverImageReducer = () => (dispatch, getState, sdk) => {
  dispatch(toggleCoverImageModal());
}

export const toggelImageReducer = () => (dispatch, getState, sdk) => {
  dispatch(toggleImageModal());
};

export const toggelVideoReducer = () => (dispatch, getState, sdk) => {
  dispatch(toggleVideoUpload());
};
export const toggelReplyGiphyReducer = () => (dispatch, getState, sdk) => {
  dispatch(toggleReplyGiphy());
};

export const toggelReplyDocumentReducer = () => (dispatch, getState, sdk) => {
  dispatch(toggleReplyDocumentModal());
};

export const toggelReplyImageReducer = () => (dispatch, getState, sdk) => {
  dispatch(toggleReplyImageModal());
};

export const toggelReplyVideoReducer = () => (dispatch, getState, sdk) => {
  dispatch(toggleReplyVideoUpload());
};

export const toggleReplyEmojiReducer = (params) => (dispatch, getState, sdk) => {
  dispatch(toggleReplyEmoji(params));
};

export const toggelRequestSpaceReducer = (param) => (dispatch, getState, sdk) => {
  dispatch(toggleRequestSpace(param));
  dispatch(fetchSpaceList({}));
};

export const requestMemberDetail = () => ({
  type: REQUEST_MEMBER_DETAIL,
});
export const successMemberDetail = data => ({
  type: SUCCESS_MEMBER_DETAIL,
  payload: { data },
});
export const errorMemberDetail = error => ({
  type: ERROR_MEMBER_DETAIL,
  payload: { error },
});

export const requestCommentReplyList = () => ({
  type: REQUEST_COMMENT_REPLIES
})

export const successCommentReplyList = (data, commentId) => ({
  type: SUCCESS_COMMENT_REPLIES,
  payload: { data, commentId },
})

export const errorCommentReplyList = error => ({
  type: ERROR_COMMENT_REPLIES,
  payload: { error },
})

export const requestMarkAllNotification = () => ({
  type: REQUEST_MARKALL_NOTIFICATIONS_AS_READ
})

export const successMarkAllNotification = data => ({
  type: SUCCESS_MARKALL_NOTIFICATIONS_AS_READ,
  payload: { data },
})

export const errorMarkAllNotification = error => ({
  type: ERROR_MARKALL_NOTIFICATIONS_AS_READ,
  payload: { error },
})

export const requestNotificationPreference = () => ({
  type: REQUEST_NOTIFICATION_PREFERENCES
})

export const successNotificationPreference = (data) => ({
  type: SUCCESS_NOTIFICATION_PREFERENCES,
  payload: {data}
})

export const errorNotificationPreference = (error) => ({
  type: ERROR_NOTIFICATION_PREFERENCES,
  payload: {error}
})

export const fetchUserActivityRequest = () => ({
  type: FETCH_USER_ACTIVITY_REQUEST
})

export const fetchUserActivitySuccess = (data) => ({
  type: FETCH_USER_ACTIVITY_SUCCESS,
  payload: data
})

export const fetchUserActivityError = (error) => ({
  type: FETCH_USER_ACTIVITY_ERROR,
  payload: error
})

export const requestAddMember = () => ({
  type: REQUEST_ADD_MEMBER
})

export const successAddMember = (response) => ({
  type: SUCCESS_ADD_MEMBER,
  payload: response
})

export const errorAddMember = (error) =>({
  type: ERROR_ADD_MEMBER,
  payload: {error}
})

export const requestGroupPostSearch = (page) => ({
  type: REQUEST_GROUP_POST_SEARCH,
  payload: {page}
});

export const successGroupPostSearch = data => ({
  type: SUCCESS_GROUP_POST_SEARCH,
  payload: { data },
});

export const errorGroupPostSearch = error => ({
  type: ERROR_GROUP_POST_SEARCH,
  payload: { error },
});

export const requestUploadDocument = () => ({
  type: UPLOAD_DOCUMENT_REQUEST
});

export const successUploadDocument = (response) => ({
  type: UPLOAD_DOCUMENT_SUCCESS,
  payload: response
});

export const errorUploadDocument = (error) => ({
  type: UPLOAD_DOCUMENT_ERROR,
  payload: { error }
});

export const onGetCircleAuthToken = async email => {
  if (typeof window === 'undefined') return {};

  // Retrieve the stored token from localStorage
  const storedToken = localStorage.getItem(LOCAL_STORAGE_CIRCLE_AUTH_TOKEN);
  const tokenData = storedToken ? JSON.parse(storedToken) : {};

  const { access_token, access_token_expires_at, community_member_id , refresh_token , success, message } = tokenData;
  // Check if the access token exists and is expired
  const isTokenExpired =
    access_token_expires_at && moment(access_token_expires_at).isBefore(moment());

    if(access_token && !isTokenExpired) {
    //check if member is deleted from circle directly
    const response = await checkCircleMemberExists({access_token});
    if(!response?.id){
      return response
    }
  }

  if (!access_token || !community_member_id || isTokenExpired) {
    // Request a new token if the current one is invalid or expired
    const newToken = await getCircleAuthToken({ email });
    if (newToken) {
      localStorage.setItem(LOCAL_STORAGE_CIRCLE_AUTH_TOKEN, JSON.stringify(newToken));
    }
    return newToken;
 }

  // Return the existing valid token
  return {
    access_token,
    community_member_id,
    success,
    message,
  };
};

export const fetchCircleAuthToken = params => async (dispatch, getState, sdk) => {
  try {
    const { page = 1 } = params || {};
    dispatch(requestAccessToken());

    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token, community_member_id , success, message} = await onGetCircleAuthToken(email);
    dispatch(successAccessToken(access_token ?? {success, message}));

    if (access_token && community_member_id) {
      dispatch(setActiveTab(FEED_TAB))
      return Promise.all([
        dispatch(fetchHomePage({ access_token, page })),
        dispatch(fetchCommunityMember(access_token, community_member_id)),
        dispatch(fetchSpaceList()),
        dispatch(fetchSpaceListV2()),
        dispatch(getNotificationsList()),
      ]);
    }
  } catch (error) {
    dispatch(errorAccessToken(error));
  }
};

export const fetchCommunityMember = () => async (dispatch, getState, sdk) => {
  try {
    dispatch(requestCommunityMember());

    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token, community_member_id, success, message } = await onGetCircleAuthToken(email);

    dispatch(successAccessToken(access_token ?? {success, message}));

    const memberResponse = await fetchCurrentCommunityMember({
      accessToken: access_token,
      community_member_id,
    });
    dispatch(successCommunityMember(memberResponse));
    return memberResponse;
  } catch (error) {
    dispatch(errorCommunityMember(error));
  }
};

export const fetchHomePage = params => async (dispatch, getState, sdk) => {
  try {
    const { page = 1, sort = 'latest', per_page = 20 } = params;

    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);

    dispatch(requestHomePage(page));
    const response = await getCircleHomePageApi({ accessToken: access_token, page, sort , per_page });
    dispatch(successHomePage(response));
  } catch (error) {
    dispatch(errorHomePage(error));
  }
};

export const createSpacePost = (apiParams, spaceId, postId = null) => async (
  dispatch,
  getState,
  sdk
) => {
  try {
    dispatch(requestCreatePost());

    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);

    const params = { accessToken: access_token, spaceId, postId, data: apiParams };
    //by using admin api we can edit some attributes of post, like comment on/off
    let response = null;
    if (postId) {
      response = await editCirclePostApi(params);
      if (response) {
        const spaceResponse = await getSpaceDetailsApi({
          accessToken: access_token,
          spaceId: spaceId,
        });
        dispatch(successSpaceDetails(spaceResponse));
      }
    } else {

     response = await createSpacePostApi(params);
    }
     dispatch(successCreatePost(response));
      // Run this asynchronously without blocking the response return
      if (response?.tiptap_body?.attachments.length) {
        (async () => {
          try {
            const updatedResponse = await getMediaTranscodingStatusApi({
              postId: response.id,
              accessToken: access_token,
              spaceId: spaceId
            });
            dispatch(successCreatePost(updatedResponse));
          } catch (error) {
            console.error("Media transcoding check failed:", error);
          }
        })();
      }
    return response;
  } catch (error) {
    dispatch(errorCreatePost(error));
  }
};

export const createLikeDislikeForPost = (is_liked = false, postId, spaceId) => async (
  dispatch,
  getState,
  sdk
) => {
  try {
    const { requestLikePost } = getState().CircleCommunityPage;

    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);

    if (requestLikePost) return;
    dispatch(requestLikeDislikePost(postId));
    //accessToken, spaceId, data
    const params = { accessToken: access_token, postId };
    let response = null;
    if (!is_liked) {
      response = await createLikeForPostApi(params);
    } else {
      response = await createDislikeForPostApi(params);
    }
    if (response?.success) {
      dispatch(fetchSpecificPost({ spaceId, postId }));
    }
    dispatch(successLikeDislikePost(response));
    return response;
  } catch (error) {
    dispatch(errorLikeDislikePost(postId, error));
  }
};

export const createCommentForPost = (params, postId) => async (dispatch, getState, sdk) => {
  try {
    dispatch(requestCreateComment());

    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);

    const response = await createCommentForPostApi({
      accessToken: access_token,
      postId,
      data: params,
    });
    dispatch(successCreateComment(response));
    if(response?.tiptap_body?.attachments.length){
      const updatedResponse = await getMediaTranscodingStatusApi({postId: postId,commentID: response.id, accessToken: access_token})

      dispatch(successCreateComment(updatedResponse));
    }
    return response;
  } catch (error) {
    dispatch(errorCreateComment(error));
  }
};

export const deleteCommentFromPost = (postId, commentID) => async (dispatch, getState, sdk) => {
  try {
    dispatch(requestDeleteComment());

    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);

    const response = await deleteCommentFromPostApi({
      accessToken: access_token,
      postId,
      commentID,
    });
    dispatch(successDeleteComment(response, commentID));
    return response;
  } catch (error) {
    dispatch(errorDeleteComment(error));
  }
};

export const fetchSpaceList = () => async (dispatch, getState, sdk) => {
  try {
    dispatch(requestSpaceList());

    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);

    const response = await fetchSpaceListApi({ accessToken: access_token });

    // const formattedResponse = groupBySpaceGroupName(response);
    dispatch(successSpaceList(response));
    if (response) {
      dispatch(fetchCombineSpaceTopics({}));
    }
    return response;
  } catch (error) {
    dispatch(errorSpaceList(error));
  }
};
export const fetchSpaceListV2 = () => async (dispatch, getState, sdk) => {
  try {
    dispatch(requestSpaceListV2());

    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);

    const response = await fetchSpaceListApiV2({ accessToken: access_token });

    // const formattedResponse = groupBySpaceGroupName(response);
    dispatch(successSpaceListV2(response.records));
    // if (response) {
    //   dispatch(fetchCombineSpaceTopics({}));
    // }
    return response;
  } catch (error) {
    dispatch(errorSpaceListV2(error));
  }
};

export const createNewCircleUser = params => async (dispatch, getState, sdk) => {
  try {
    dispatch(requestCreateUser());
    const response = await createNewCircleUserApi(params);
    dispatch(successCreateUser(response));
    return response;
  } catch (error) {
    dispatch(errorCreateUser(error));
  }
};

const uploadWithMulter = async (file, direct_upload) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('direct_upload', JSON.stringify(direct_upload));

  const multipartResponse = await fetch(
    'http://localhost:3500/api/cloudfare/upload-file-with-multer',
    {
      method: 'POST',
      // headers: {
      //   'Content-Type': 'multipart/form-data',
      // },
      body: formData,
    }
  );
};

const uploadFileFromFrontend = async (file, direct_upload) => {
  const fileResponse = await fetch(direct_upload.url, {
    method: 'PUT',
    headers: direct_upload.headers,
    body: file, // Send the file directly as the body
  });
  return fileResponse.status;
};

export const createDirectUpload = (params, file) => async (dispatch, getState) => {
  try {
    dispatch(requestDirectUpload());

    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);

    const response = await directUploadApi({ accessToken: access_token, body: params });
    const { direct_upload } = response;

    await uploadFileFromFrontend(file, direct_upload);

    dispatch(successDirectUpload({}));
    return response;
  } catch (error) {
    dispatch(errorDirectUpload(error));
  }
};

export const createNewSpace = params => async (dispatch, getState, sdk) => {
  try {
    dispatch(requestNewSpace());

    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);

    const response = await createNewSpaceApi({ accessToken: access_token, data: params });
    dispatch(successNewSpace(response));
    return response;
  } catch (error) {
    dispatch(errorNewSpace(error));
  }
};

export const joinSpace = params => async (dispatch, getState, sdk) => {
  try {
    dispatch(requestJoinSpace());

    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);

    const response = await joinSpaceByIdApi({ accessToken: access_token, spaceId: params });
    dispatch(getSpaceDetails({ spaceId: params }));
    dispatch(successJoinSpace(response));
    return response;
  } catch (error) {
    dispatch(errorJoinSpace(error));
  }
};

export const leaveSpace = params => async (dispatch, getState, sdk) => {
  try {
    dispatch(requestLeaveSpace());

    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);

    const response = await leaveSpaceByIdApi({ accessToken: access_token, spaceId: params });
    dispatch(getSpaceDetails({ spaceId: params }));
    dispatch(successLeaveSpace(response));
    return response;
  } catch (error) {
    dispatch(errorLeaveSpace(error));
  }
};

export const fetchCombineSpaceTopics = params => async (dispatch, getState, sdk) => {
  try {
    dispatch(requestCombineSpaceTopics());
    const { spaceListData } = getState().CircleCommunityPage;

    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);

    const reponse = await trendingTopicsApi({ accessToken: access_token, spaceListData });
    dispatch(successCombineSpaceTopics(reponse));
    return reponse;
  } catch (error) { }
};

export const createBookMark = params => async (dispatch, getState, sdk) => {
  const { spaceId, postId, record_id, bookmark_type } = params;
  try {
    const { requestCreateBookmark: requestCreate } = getState().CircleCommunityPage;

    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);

    if (requestCreate) return;
    dispatch(requestCreateBookmark(postId));
    const bodyParam = {
      record_id,
      bookmark_type,
    };
    const response = await createBookMarkApi({ accessToken: access_token, body: bodyParam });
    dispatch(fetchSpecificPost({ spaceId, postId }));
    dispatch(successCreateBookmark(response));
    return response;
  } catch (error) {
    dispatch(errorCreateBookmark(postId, error));
  }
};

export const deleteBookMark = params => async (dispatch, getState, sdk) => {
  const { spaceId, postId, bookmarkId } = params;
  try {
    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);

    const { requestDeleteBookmark: removeBookmark } = getState().CircleCommunityPage;

    if (removeBookmark) return;
    dispatch(requestDeleteBookmark(postId));
    const response = await deleteBookMarkApi({ accessToken: access_token, bookmarkId: bookmarkId });
    dispatch(fetchSpecificPost({ spaceId, postId }));
    dispatch(successDeleteBookmark(response));
    return response;
  } catch (error) {
    dispatch(errorDeleteBookmark(postId, error));
  }
};

export const fetchBookMarList = params => async (dispatch, getState, sdk) => {
  try {
    dispatch(requestBookmarksList());

    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);

    const response = await getBookMarksApi({ accessToken: access_token });
    dispatch(successBookmarksList(response));
    return response;
  } catch (error) {
    dispatch(errorBookmarksList(error));
  }
};

export const fetchSpecificPost = params => async (dispatch, getState) => {
  try {
    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);

    dispatch(requestSinglePost());
    const response = await getSinglePostApi({
      accessToken: access_token,
      spaceId: params.spaceId,
      postId: params.postId,
    });
    dispatch(successSinglePost(response));
    if (response?.tiptap_body?.attachments.length) {
      (async () => {
        try {
          const updatedResponse = await getMediaTranscodingStatusApi({
            postId: response.id,
            accessToken: access_token,
            spaceId: params.spaceId
          });
          dispatch(successSinglePost(updatedResponse));
        } catch (error) {
          console.error("Media transcoding check failed:", error);
        }
      })();
    }

    return response;
  } catch (error) {
    dispatch(errorSinglePost(error));
  }
};

export const fetchPostCommentList = params => async (dispatch, getState) => {
  try {
    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);
    const { page = 1, per_page = 2, postId = '' } = params
    dispatch(requestPostCommentList(page));
    const response = await getCommentListForPostApi({
      accessToken: access_token,
      ...params
      // postId: params.postId,
    });
    dispatch(successPostCommentList(response, postId));
    return response;
  } catch (error) {
    dispatch(errorPostCommentList(error));
  }
};

export const createLikeDislikeComment = params => async (dispatch, getState) => {
  try {
    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);

    dispatch(requestLikeDislikeComment(params.commentId));
    const response = await createLikeDislikeCommentApi({
      accessToken: access_token,
      commentId: params.commentId,
      isLiked: params.is_liked,
    });
    dispatch(successLikeDislikeComment(response));
    return response;
  } catch (error) {
    dispatch(errorLikeDislikeComment(params.commentId, error));
  }
};

export const createReplyComment = params => async (dispatch, getState) => {
  try {
    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);

    dispatch(requestCommentReply());

    const response = await createReplyForACommentApi({
      accessToken: access_token,
      data: params.bodyParams,
      commentId: params.commentId,
    });
    dispatch(successCommentReply(response));
    return response;
  } catch (error) {
    dispatch(errorCommentReply(error));
  }
};

export const getSpaceDetails = params => async (dispatch, getState) => {
  try {
    const { page = 1, sort, per_page = 20 } = params;

    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);
    dispatch(fetchCommunityMember());
    dispatch(requestSpaceDetails(page));
    const response = await getSpaceDetailsApi({
      accessToken: access_token,
      spaceId: params.spaceId,
      page,
      sort,
      per_page,
      topicId : params?.topicId
    });
    dispatch(getSpaceMembersList({ space_id: params.spaceId }, false));
    dispatch(successSpaceDetails(response));
    return response;
  } catch (error) {
    dispatch(errorSpaceDetails(error));
  }
};

export const getSpaceTopicDetails = params => async (dispatch, getState) => {
  try {
    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);

    dispatch(requestTopicDetails());
    const response = await getSpaceTopicDetailApi({
      accessToken: access_token,
      spaceId: params.spaceId,
      topicId: params.topicId,
    });
    dispatch(successTopicDetails(response));
    return response;
  } catch (error) {
    dispatch(errorTopicDetails(error));
  }
};

export const getSpaceMembersList = (params, isShowFullList = false, isAdmin = false) => async (
  dispatch,
  getState
) => {
  try {
    dispatch(requestSpaceMembersList());

    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);

    const response = await getSpaceMembersApi({ accessToken: access_token, data: params, isAdmin });
    if (isShowFullList) {
      dispatch(successSpaceMemberFullList(response));
      return response;
    } else {
      dispatch(successSpaceMembersList(response));
      return response;
    }
  } catch (error) {
    dispatch(errorSpaceMembersList(error));
  }
};

export const requestToJoinGroupNotify = (params) => (dispatch, getState) => {
  return onMultiMailApiCollection(params);
};


export const uploadDocument = (params) => (dispatch, getState) => {
  dispatch(requestUploadDocument());
  return UploadImage({ ...params }).then((response) => {
    dispatch(successUploadDocument(response));
    return response;
  })
    .catch((error) => {
      dispatch(errorUploadDocument(storableError(error)));
    })
};

export const removeSpaceMember = params => async (dispatch, getState) => {
  try {
    dispatch(requestRemoveSpaceMember());

    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);
    const response = await removeSpaceMemberApi({
      accessToken: access_token,
      email: params.email,
      space_id: params.spaceId,
      community_member_id: params.community_member_id
    });

    dispatch(successRemoveSpaceMember({}, params?.community_member_id));
    return;
  } catch (error) {
    dispatch(errorRemoveSpaceMember(error));
  }
};

export const deleteSpace = params => async (dispatch, getState) => {
  try {
    dispatch(requestDeleteSpace());

    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);

    const response = await deleteSpaceApi({ accessToken: access_token, space_id: params });
    dispatch(getSpaceDetails({ spaceId: params }));
    dispatch(successDeleteSpace(response));
    return response;
  } catch (error) {
    dispatch(errorDeleteSpace(error));
  }
};

export const advancedSearch = params => async (dispatch, getState) => {
  try {
    dispatch(requestAdvancedSearch());

    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);

    const response = await advancedSearchApi({ accessToken: access_token, ...params });
    dispatch(successAdvancedSearch(response));
    return response;
  } catch (error) {
    dispatch(errorAdvancedSearch(error));
  }
};

export const editCommentForPost = (params, postId, commentID) => async (dispatch, getState) => {
  try {
    dispatch(requestEditComment());

    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);

    const response = await editCommentApi({
      accessToken: access_token,
      postId,
      commentID,
      data: params,
    });

    dispatch(successEditComment(response));
    return response;
  } catch (error) {
    dispatch(errorEditComment(error));
  }
};

export const deleteCirclePost = (postId, spaceId) => async (dispatch, getState) => {
  try {
    dispatch(requestDeletePost(postId));
    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);

    const response = await deleteCirclePostApi({ accessToken: access_token, postId, spaceId });
    if (response?.success) {
      dispatch(successDeletePost(postId));
    }
    return response;
  } catch (error) {
    dispatch(errorDeletePost(error));
  }
};

export const followUnfollowPost = (postId, spaceId, post_follower_id) => async (
  dispatch,
  getState
) => {
  try {
    dispatch(requestFollowPost(postId));
    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);

    const response = await followCirclePostApi({
      accessToken: access_token,
      postId,
      spaceId,
      post_follower_id,
    });

    dispatch(successFollowPost(response));

    return response;
  } catch (error) {
    dispatch(errorFollowPost(error));
  }
};

export const flaggedContent = params => async (dispatch, getState) => {
  try {
    dispatch(requestFlaggedContent());

    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email); // accessToken: access_token,

    const response = await flaggedContentApi({ accessToken: access_token, data: params });
    dispatch(successFlaggedContent(response));
    dispatch(toggleReportContent());
    return response;
  } catch (error) {
    dispatch(errorFlaggedContent(error));
  }
};

export const getSpaceTopics = params => async (dispatch, getState) => {
  try {
    dispatch(requestSpaceTopics());
    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);
    const response = await getSpaceTopicsApi({ accessToken: access_token, spaceId: params });
    dispatch(successSpaceTopics(response));
    return response;
  } catch (error) {
    dispatch(errorSpaceTopics(error));
  }
};

export const getNotificationsList = params => async (dispatch, getState) => {
  try {
    dispatch(requestNotifications());
    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);
    const response = await getNotificationsListApi({ accessToken: access_token });
    dispatch(successNotifications(response));
    return response;
  } catch (error) {
    console.log('error', error);
    dispatch(errorNotifications(error));
  }
};

export const getNotificationsCount = () => async (dispatch, getState) => {
  try {
    dispatch(requestNotificationCount());
    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);
    const response = await getNotificationsCountApi({ accessToken: access_token });
    dispatch(successNotificationCount(response));
    return response;
  } catch (error) {
    console.log('error', error);
    dispatch(errorNotificationCount(error));
  }
};

export const markNotificationAsRead = params => async (dispatch, getState) => {
  try {
    dispatch(requestMarkAsRead());
    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);
    const response = await markNotificationAsReadApi({ accessToken: access_token, id: params });
    dispatch(successMarkAsRead(response));
    return response;
  } catch (error) {
    console.log('error', error);
    dispatch(errorMarkAsRead(error));
  }
};
export const resetNotificationCount = params => async (dispatch, getState) => {
  try {
    dispatch(requestResetNotifications());
    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);
    const response = await resetNotificationCountApi({ accessToken: access_token });
    dispatch(successResetNotifications(response));
    return response;
  } catch (error) {
    console.log('error', error);
    dispatch(errorResetNotifications(error));
  }
};

export const getMemberDetail = params => async (dispatch, getState) => {
  try {
    dispatch(requestMemberDetail());
    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);
    const response = await getMemberDetailApi({ accessToken: access_token, community_member_id: params });
    dispatch(successMemberDetail(response));
    return response;
  } catch (error) {
    console.log('error', error);
    dispatch(errorMemberDetail(error));
  }
};

export const loadMoreReplyComments = params => async (dispatch, getState) => {
  try {
    dispatch(requestCommentReplyList())
    const { page, per_page, commentId } = params
    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);
    const response = await getListOfReplyForCommentApi({ accessToken: access_token, ...params })

    dispatch(successCommentReplyList(response, commentId))
    return response
  } catch (error) {
    dispatch(errorCommentReplyList(error))
  }
}

export const markAllNotificationsAsRead = () => async (dispatch, getState) => {
  try {
    dispatch(requestMarkAllNotification())
    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);
    const resposne = await markAllNotificationsAsReadApi({ accessToken: access_token })
    console.log('resposne....', resposne)
    dispatch(getNotificationsList())
    dispatch(successMarkAllNotification(resposne))
    return resposne
  } catch (error) {
    dispatch(errorMarkAllNotification(error))
  }
}

export const getNotificationPreference = () => async (dispatch, getState) => {
  try {
    dispatch(requestNotificationPreference())
    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);
    const resposne = await getNotificationPrefernceApi({ accessToken: access_token })
    dispatch(successNotificationPreference(resposne))
    return resposne
  } catch (error) {
    dispatch(errorNotificationPreference(error))
  }
}

export const updateNotificationPreference = (params) => async (dispatch, getState) => {
  try {
    dispatch(requestNotificationPreference())
    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);
    const resposne = await notificationPreferencesApi({ accessToken: access_token ,...params})
    dispatch(getNotificationPreference())
    // dispatch(successNotificationPreference(resposne))
    return resposne
  } catch (error) {
    dispatch(errorNotificationPreference(error))
  }
}

export const fetchUserActivity = (params) => async (dispatch, getState) => {
  try {
    dispatch(fetchUserActivityRequest())
    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);
    const response = await fetchUserActivityApi({ accessToken: access_token, ...params });
    dispatch(fetchUserActivitySuccess(response))
  } catch (e) {
    console.log(e, '%%% %%% => e');
    dispatch(fetchUserActivityError(e));
  }
};

export const addMemberToSpace = params => async (dispatch, getState) => {
  try {
    dispatch(requestAddMember())
    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);
    const response = await addMemberToSpaceApi({ accessToken: access_token, ...params })
    dispatch(successAddMember(response))
    return response
  } catch (error) {
    dispatch(errorAddMember(error))
  }
}

export const groupPostSearch = params => async (dispatch, getState) => {
  try {
     const {page = 1} = params
    dispatch(requestGroupPostSearch(page));
    const email = getState()?.user?.currentUser?.attributes?.email;
    const { access_token } = await onGetCircleAuthToken(email);
    const response = await groupPostSearchApi({ accessToken: access_token, ...params });
    dispatch(successGroupPostSearch(response));
    return response;
  } catch (error) {
    dispatch(errorGroupPostSearch(error));
  }
};

export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {
  const { page = 1 } = parse(search);
  const { postId, spaceId } = params;
  const { currentUser } = getState().user;
  try {
    if (!currentUser) {
      await dispatch(fetchCurrentUser());
    }
    if (postId && spaceId) {
      dispatch(fetchSpecificPost({ postId, spaceId }))
      dispatch(getSpaceMembersList({ space_id: spaceId }, false));
    }
  } catch (e) {
    console.log(e, '&&& &&& => e');
  }

  return dispatch(fetchCircleAuthToken({ page: +page }));
};
